import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Color: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Email: { input: string; output: string; }
  JSON: { input: object; output: object; }
  Password: { input: string; output: string; }
  PhoneNumber: { input: string; output: string; }
  Time: { input: string; output: string; }
}

export interface AcceptInvitationInput {
  password: Scalars['Password']['input'];
  token: Scalars['String']['input'];
}

export interface Account {
  __typename?: 'Account';
  billingInfo?: Maybe<BillingInfo>;
  businessHours?: Maybe<Array<BusinessHours>>;
  courts: ListCourtsResult;
  createdAt: Scalars['DateTime']['output'];
  customers: ListCustomersResult;
  employees: ListEmployeesResult;
  id: Scalars['ID']['output'];
  jobFinishedSmsTemplate?: Maybe<Scalars['String']['output']>;
  jobs: ListJobsResult;
  messages: ListMessagesResult;
  name: Scalars['String']['output'];
  notificationsPhoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  phone: Scalars['PhoneNumber']['output'];
  reservations: ListReservationsResult;
  status: AccountStatus;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workShifts: ListWorkShiftsResult;
}


export interface AccountCourtsArgs {
  filter?: InputMaybe<CourtFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountCustomersArgs {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountEmployeesArgs {
  filter?: InputMaybe<EmployeeFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountJobsArgs {
  filter?: InputMaybe<JobFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountMessagesArgs {
  filter?: InputMaybe<MessageFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountReservationsArgs {
  filter?: InputMaybe<ReservationFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface AccountWorkShiftsArgs {
  filter?: InputMaybe<WorkShiftFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}

export interface AccountFilter {
  createdAt?: InputMaybe<DateFilter>;
  jobFinishedSmsTemplate?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  notificationsPhoneNumber?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountStatus>;
  stripeSubscriptionId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
}

export type AccountStatus =
  | 'ACTIVE'
  | 'CANCELED'
  | 'DELINQUENT'
  | 'DEMO'
  | 'PENDING_SETUP'
  | 'TRIAL';

export interface AccountSummary {
  __typename?: 'AccountSummary';
  jobsByMonth: Array<MonthJobCount>;
  unfinishedJobs: Scalars['Int']['output'];
}

export interface BillingCustomerInfo {
  __typename?: 'BillingCustomerInfo';
  address?: Maybe<Scalars['JSON']['output']>;
  delinquent: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceSettings: InvoiceSettings;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
}

export interface BillingInfo {
  __typename?: 'BillingInfo';
  currentSubscription?: Maybe<Subscription>;
  customer?: Maybe<BillingCustomerInfo>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  subscriptions?: Maybe<Array<Subscription>>;
}

export type BillingInterval =
  | 'MONTHLY'
  | 'YEARLY';

export interface BooleanFilter {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface BusinessHours {
  __typename?: 'BusinessHours';
  daysOfWeek: Array<Scalars['Int']['output']>;
  endTime: Scalars['Time']['output'];
  startTime: Scalars['Time']['output'];
}

export interface BusinessHoursInput {
  daysOfWeek: Array<Scalars['Int']['input']>;
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
}

export interface CancelSubscription {
  cancelDescription?: InputMaybe<Scalars['String']['input']>;
  cancelReasonCode?: InputMaybe<Scalars['String']['input']>;
}

export interface Card {
  __typename?: 'Card';
  brand: Scalars['String']['output'];
  country: Scalars['String']['output'];
  displayBrand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  funding: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
}

export interface ChangeAccountPlanInput {
  planId: Scalars['ID']['input'];
}

export interface ChangeUserPasswordInput {
  currentPassword: Scalars['Password']['input'];
  newPassword: Scalars['Password']['input'];
}

export interface ClockInOutInput {
  clockTime?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ConfirmSignUpInput {
  sub: Scalars['String']['input'];
}

export interface Coupon {
  __typename?: 'Coupon';
  amountOff?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['String']['output'];
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
  redeemBy?: Maybe<Scalars['DateTime']['output']>;
}

export interface Court {
  __typename?: 'Court';
  account: Account;
  accountId: Scalars['ID']['output'];
  color?: Maybe<Scalars['Color']['output']>;
  coverage?: Maybe<CourtCoverage>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: CourtLocation;
  name: Scalars['String']['output'];
  nextReservation?: Maybe<Reservation>;
  order?: Maybe<Scalars['Int']['output']>;
  reservationsToday?: Maybe<Scalars['Int']['output']>;
  surface?: Maybe<CourtSurface>;
  updatedAt: Scalars['DateTime']['output'];
}

export type CourtCoverage =
  | 'INDOOR'
  | 'OUTDOOR_COVERED'
  | 'OUTDOOR_UNCOVERED';

export interface CourtFilter {
  color?: InputMaybe<Scalars['Color']['input']>;
  coverage?: InputMaybe<CourtCoverage>;
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<CourtSurface>;
  updatedAt?: InputMaybe<DateFilter>;
}

export interface CourtLocation {
  __typename?: 'CourtLocation';
  rotation: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
}

export interface CourtLocationInput {
  rotation: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
}

export type CourtSurface =
  | 'CARPET'
  | 'CLAY'
  | 'GRASS'
  | 'HARD';

export interface CreateAccountInput {
  businessHours?: InputMaybe<Array<BusinessHoursInput>>;
  jobFinishedSmsTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationsPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  phone: Scalars['PhoneNumber']['input'];
  status: AccountStatus;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface CreateCourtInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  coverage?: InputMaybe<CourtCoverage>;
  location: CourtLocationInput;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  surface?: InputMaybe<CourtSurface>;
}

export interface CreateCustomerInput {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  memNumber?: InputMaybe<Scalars['String']['input']>;
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  ntrpRating?: InputMaybe<NtrpRating>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateDemoAccountInput {
  companyName?: InputMaybe<Scalars['String']['input']>;
  customers?: InputMaybe<Scalars['Int']['input']>;
  employees?: InputMaybe<Scalars['Int']['input']>;
  jobsPerCustomer?: InputMaybe<Scalars['Int']['input']>;
}

export interface CreateEmployeeInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  role: EmployeeRole;
  status: EmployeeStatus;
}

export interface CreateJobInput {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishedById?: InputMaybe<Scalars['ID']['input']>;
  gauge?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  racket?: InputMaybe<Scalars['String']['input']>;
  racketType?: InputMaybe<RacketType>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: JobStatus;
  stringName?: InputMaybe<Scalars['String']['input']>;
  tension?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateMessageInput {
  body: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  fromPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  toPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
}

export interface CreateReservationInput {
  courtId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
  status: ReservationStatus;
}

export interface CreateReservationSeriesInput {
  courtId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency: FrequencyPatternInput;
  initialReservations?: InputMaybe<Array<CreateReservationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate: Scalars['DateTime']['input'];
}

export interface CreateWorkShiftInput {
  employeeId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  status: WorkShiftStatus;
}

export interface Customer {
  __typename?: 'Customer';
  account: Account;
  accountId: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  homePhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobs: ListJobsResult;
  lastName?: Maybe<Scalars['String']['output']>;
  memNumber?: Maybe<Scalars['String']['output']>;
  messages: ListMessagesResult;
  middleInitial?: Maybe<Scalars['String']['output']>;
  ntrpRating?: Maybe<NtrpRating>;
  updatedAt: Scalars['DateTime']['output'];
  workPhone?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
}


export interface CustomerJobsArgs {
  filter?: InputMaybe<JobFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface CustomerMessagesArgs {
  filter?: InputMaybe<MessageFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}

export interface CustomerFilter {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringFilter>;
  cellPhone?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  gender?: InputMaybe<Gender>;
  homePhone?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  memNumber?: InputMaybe<StringFilter>;
  middleInitial?: InputMaybe<StringFilter>;
  ntrpRating?: InputMaybe<NtrpRating>;
  q?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateFilter>;
  workPhone?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
}

export interface DateFilter {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface Employee {
  __typename?: 'Employee';
  account: Account;
  accountId: Scalars['ID']['output'];
  color?: Maybe<Scalars['Color']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentWorkShift?: Maybe<WorkShift>;
  email: Scalars['Email']['output'];
  firstName: Scalars['String']['output'];
  hoursWorkedThisWeek?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  jobsFinished: ListJobsResult;
  jobsFinishedCount?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  messagesSent: ListMessagesResult;
  permissions: Array<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['JSON']['output']>;
  role: EmployeeRole;
  status: EmployeeStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  workShifts: ListWorkShiftsResult;
}


export interface EmployeeJobsFinishedArgs {
  filter?: InputMaybe<JobFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface EmployeeMessagesSentArgs {
  filter?: InputMaybe<MessageFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface EmployeeWorkShiftsArgs {
  filter?: InputMaybe<WorkShiftFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}

export interface EmployeeFilter {
  accountId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EmployeeRole>;
  status?: InputMaybe<EmployeeStatus>;
  updatedAt?: InputMaybe<DateFilter>;
}

export type EmployeeRole =
  | 'ACCOUNT_ADMIN'
  | 'ACCOUNT_OWNER'
  | 'EMPLOYEE';

export type EmployeeStatus =
  | 'ACTIVE'
  | 'DEACTIVATED'
  | 'INVITED';

export interface Entitlement {
  __typename?: 'Entitlement';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
}

export interface Error {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface FloatFilter {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
}

export interface FrequencyPattern {
  __typename?: 'FrequencyPattern';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['Int']['output']>;
  type: FrequencyType;
  weekOfMonth?: Maybe<Scalars['Int']['output']>;
}

export interface FrequencyPatternInput {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  type: FrequencyType;
  weekOfMonth?: InputMaybe<Scalars['Int']['input']>;
}

export type FrequencyType =
  | 'BIWEEKLY'
  | 'CUSTOM'
  | 'DAILY'
  | 'MONTHLY'
  | 'WEEKLY';

export type Gender =
  | 'FEMALE'
  | 'MALE';

export interface IntFilter {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
}

export interface InviteEmployeeInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  role: EmployeeRole;
}

export interface InvoiceSettings {
  __typename?: 'InvoiceSettings';
  defaultPaymentMethod?: Maybe<Scalars['String']['output']>;
}

export interface Job {
  __typename?: 'Job';
  account: Account;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedBy?: Maybe<Employee>;
  finishedById?: Maybe<Scalars['ID']['output']>;
  gauge?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  racket?: Maybe<Scalars['String']['output']>;
  racketType: RacketType;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  stringName?: Maybe<Scalars['String']['output']>;
  tension?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface JobFilter {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  finishedAt?: InputMaybe<DateFilter>;
  finishedById?: InputMaybe<Scalars['ID']['input']>;
  gauge?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  paidAt?: InputMaybe<DateFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  racket?: InputMaybe<StringFilter>;
  racketType?: InputMaybe<RacketType>;
  receivedAt?: InputMaybe<DateFilter>;
  status?: InputMaybe<JobStatus>;
  stringName?: InputMaybe<StringFilter>;
  tension?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
}

export type JobStatus =
  | 'FINISHED'
  | 'TODO';

export interface ListAccountsResult {
  __typename?: 'ListAccountsResult';
  data: Array<Account>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListCourtsResult {
  __typename?: 'ListCourtsResult';
  data: Array<Court>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListCustomersResult {
  __typename?: 'ListCustomersResult';
  data: Array<Customer>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListEmployeesResult {
  __typename?: 'ListEmployeesResult';
  data: Array<Employee>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListJobsResult {
  __typename?: 'ListJobsResult';
  data: Array<Job>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListMessagesResult {
  __typename?: 'ListMessagesResult';
  data: Array<Message>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListReservationSeriesResult {
  __typename?: 'ListReservationSeriesResult';
  data: Array<ReservationSeries>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListReservationsResult {
  __typename?: 'ListReservationsResult';
  data: Array<Reservation>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface ListWorkShiftsResult {
  __typename?: 'ListWorkShiftsResult';
  data: Array<WorkShift>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
}

export interface Message {
  __typename?: 'Message';
  account: Account;
  accountId: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  externalId: Scalars['String']['output'];
  fromPhoneNumber: Scalars['PhoneNumber']['output'];
  id: Scalars['ID']['output'];
  sentBy?: Maybe<Employee>;
  sentById?: Maybe<Scalars['ID']['output']>;
  toPhoneNumber: Scalars['PhoneNumber']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface MessageFilter {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<StringFilter>;
  fromPhoneNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sentById?: InputMaybe<Scalars['ID']['input']>;
  toPhoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
}

export interface MonthJobCount {
  __typename?: 'MonthJobCount';
  date: Scalars['DateTime']['output'];
  jobs: Scalars['Int']['output'];
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptInvitation: User;
  cancelSubscription: Account;
  changeAccountPlan: Account;
  changeUserPassword: User;
  clockIn: WorkShift;
  clockOut: WorkShift;
  confirmSignUp: Scalars['Boolean']['output'];
  createAccount: Account;
  createCourt: Court;
  createCustomer: Customer;
  createDemoAccount: Account;
  createEmployee: Employee;
  createJob: Job;
  createMessage: Message;
  createReservation: Reservation;
  createReservationSeries: ReservationSeries;
  createWorkShift: WorkShift;
  deactivateEmployee: Employee;
  deleteAccount: Account;
  deleteCourt: Court;
  deleteCourts?: Maybe<Array<Court>>;
  deleteCustomer: Customer;
  deleteCustomers?: Maybe<Array<Customer>>;
  deleteEmployee: Employee;
  deleteEmployees?: Maybe<Array<Employee>>;
  deleteJob: Job;
  deleteJobs?: Maybe<Array<Job>>;
  deleteReservation: Reservation;
  deleteReservationSeries: ReservationSeries;
  deleteReservationSeriesList?: Maybe<Array<ReservationSeries>>;
  deleteReservations?: Maybe<Array<Reservation>>;
  deleteWorkShift: WorkShift;
  deleteWorkShifts?: Maybe<Array<WorkShift>>;
  inviteEmployee: Employee;
  pong?: Maybe<Scalars['Boolean']['output']>;
  reactivateEmployee: Employee;
  removePaymentMethod: Account;
  resendInvitation: Employee;
  resetEmployeePassword: Employee;
  saveAccountSettings: Account;
  setDefaultPaymentMethod: Account;
  setupPlan: Scalars['Boolean']['output'];
  signUp: SignUpResult;
  subscribeToPlan: Account;
  updateAccount: Account;
  updateCourt: Court;
  updateCustomer: Customer;
  updateEmployee: Employee;
  updateEmployeeSettings: Employee;
  updateJob: Job;
  updateJobStatus: Job;
  updateJobsStatus: Array<Job>;
  updateReservation: Reservation;
  updateReservationSeries: ReservationSeries;
  updateUserNotificationPreferences: User;
  updateUserPassword: User;
  updateWorkShift: WorkShift;
}


export interface MutationAcceptInvitationArgs {
  input: AcceptInvitationInput;
}


export interface MutationCancelSubscriptionArgs {
  input: CancelSubscription;
}


export interface MutationChangeAccountPlanArgs {
  input: ChangeAccountPlanInput;
}


export interface MutationChangeUserPasswordArgs {
  input: ChangeUserPasswordInput;
}


export interface MutationClockInArgs {
  input: ClockInOutInput;
}


export interface MutationClockOutArgs {
  input: ClockInOutInput;
}


export interface MutationConfirmSignUpArgs {
  input: ConfirmSignUpInput;
}


export interface MutationCreateAccountArgs {
  input: CreateAccountInput;
}


export interface MutationCreateCourtArgs {
  input: CreateCourtInput;
}


export interface MutationCreateCustomerArgs {
  input: CreateCustomerInput;
}


export interface MutationCreateDemoAccountArgs {
  input?: InputMaybe<CreateDemoAccountInput>;
}


export interface MutationCreateEmployeeArgs {
  input: CreateEmployeeInput;
}


export interface MutationCreateJobArgs {
  input: CreateJobInput;
}


export interface MutationCreateMessageArgs {
  input: CreateMessageInput;
}


export interface MutationCreateReservationArgs {
  input: CreateReservationInput;
}


export interface MutationCreateReservationSeriesArgs {
  input: CreateReservationSeriesInput;
}


export interface MutationCreateWorkShiftArgs {
  input: CreateWorkShiftInput;
}


export interface MutationDeactivateEmployeeArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteAccountArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCourtArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCourtsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteCustomerArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCustomersArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteEmployeeArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEmployeesArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteJobArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteJobsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteReservationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteReservationSeriesArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteReservationSeriesListArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteReservationsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteWorkShiftArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteWorkShiftsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationInviteEmployeeArgs {
  input: InviteEmployeeInput;
}


export interface MutationReactivateEmployeeArgs {
  id: Scalars['ID']['input'];
}


export interface MutationRemovePaymentMethodArgs {
  paymentMethodId: Scalars['ID']['input'];
}


export interface MutationResendInvitationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationResetEmployeePasswordArgs {
  id: Scalars['ID']['input'];
  newPassword: Scalars['Password']['input'];
}


export interface MutationSaveAccountSettingsArgs {
  input: SaveAccountSettingsInput;
}


export interface MutationSetDefaultPaymentMethodArgs {
  paymentMethodId: Scalars['ID']['input'];
}


export interface MutationSetupPlanArgs {
  input: SetupPlanInput;
}


export interface MutationSignUpArgs {
  input: SignUpInput;
}


export interface MutationSubscribeToPlanArgs {
  input: SubscribeToPlanInput;
}


export interface MutationUpdateAccountArgs {
  input: UpdateAccountInput;
}


export interface MutationUpdateCourtArgs {
  input: UpdateCourtInput;
}


export interface MutationUpdateCustomerArgs {
  input: UpdateCustomerInput;
}


export interface MutationUpdateEmployeeArgs {
  input: UpdateEmployeeInput;
}


export interface MutationUpdateEmployeeSettingsArgs {
  input: UpdateEmployeeSettingsInput;
}


export interface MutationUpdateJobArgs {
  input: UpdateJobInput;
}


export interface MutationUpdateJobStatusArgs {
  input: UpdateJobStatusInput;
}


export interface MutationUpdateJobsStatusArgs {
  input: UpdateJobsStatusInput;
}


export interface MutationUpdateReservationArgs {
  input: UpdateReservationInput;
}


export interface MutationUpdateReservationSeriesArgs {
  input: UpdateReservationSeriesInput;
}


export interface MutationUpdateUserNotificationPreferencesArgs {
  input: UpdateUserNotificationPreferencesInput;
}


export interface MutationUpdateUserPasswordArgs {
  input: UpdateUserPassword;
}


export interface MutationUpdateWorkShiftArgs {
  input: UpdateWorkShiftInput;
}

export type NtrpRating =
  | 'LEVEL_1_0'
  | 'LEVEL_1_5'
  | 'LEVEL_2_0'
  | 'LEVEL_2_5'
  | 'LEVEL_3_0'
  | 'LEVEL_3_5'
  | 'LEVEL_4_0'
  | 'LEVEL_4_5'
  | 'LEVEL_5_0'
  | 'LEVEL_5_5'
  | 'LEVEL_6_0'
  | 'LEVEL_6_5'
  | 'LEVEL_7_0';

export interface PageInfo {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
}

export interface PaginationInput {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}

export interface PaymentMethod {
  __typename?: 'PaymentMethod';
  billingDetails?: Maybe<Scalars['JSON']['output']>;
  card?: Maybe<Card>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
}

export interface Plan {
  __typename?: 'Plan';
  description: Scalars['String']['output'];
  features: Array<PlanFeature>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  prices: Array<PlanPrice>;
}

export interface PlanFeature {
  __typename?: 'PlanFeature';
  fullDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
}

export interface PlanPrice {
  __typename?: 'PlanPrice';
  amount: Scalars['Float']['output'];
  billingInterval: BillingInterval;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
}

export interface PriceRecurringConfig {
  __typename?: 'PriceRecurringConfig';
  interval: Scalars['String']['output'];
  intervalCount?: Maybe<Scalars['Int']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  usageType: Scalars['String']['output'];
}

export interface Query {
  __typename?: 'Query';
  accountSummary: AccountSummary;
  getAccount?: Maybe<Account>;
  getAccounts: Array<Account>;
  getActiveWorkShift?: Maybe<WorkShift>;
  getCourt?: Maybe<Court>;
  getCourts: Array<Court>;
  getCustomer?: Maybe<Customer>;
  getCustomers: Array<Customer>;
  getEmployee?: Maybe<Employee>;
  getEmployees: Array<Employee>;
  getJob?: Maybe<Job>;
  getJobs: Array<Job>;
  getMessage?: Maybe<Message>;
  getMessages: Array<Message>;
  getPlan?: Maybe<Plan>;
  getPlans: Array<Plan>;
  getReservation?: Maybe<Reservation>;
  getReservationSeries?: Maybe<ReservationSeries>;
  getReservationSeriesList: Array<ReservationSeries>;
  getReservations: Array<Reservation>;
  getWorkShift?: Maybe<WorkShift>;
  getWorkShifts: Array<WorkShift>;
  listAccounts: ListAccountsResult;
  listCourts: ListCourtsResult;
  listCustomers: ListCustomersResult;
  listEmployees: ListEmployeesResult;
  listJobs: ListJobsResult;
  listMessages: ListMessagesResult;
  listPlans: Array<Plan>;
  listReservationSeries: ListReservationSeriesResult;
  listReservations: ListReservationsResult;
  listWorkShifts: ListWorkShiftsResult;
  me: Employee;
  myAccount?: Maybe<Account>;
  ping?: Maybe<Scalars['Boolean']['output']>;
}


export interface QueryGetAccountArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetAccountsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetActiveWorkShiftArgs {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryGetCourtArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetCourtsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetCustomerArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetCustomersArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetEmployeeArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetEmployeesArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetJobArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetJobsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetMessageArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetMessagesArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetPlanArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetPlansArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetReservationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetReservationSeriesArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetReservationSeriesListArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetReservationsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryGetWorkShiftArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetWorkShiftsArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QueryListAccountsArgs {
  filter?: InputMaybe<AccountFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListCourtsArgs {
  filter?: InputMaybe<CourtFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListCustomersArgs {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListEmployeesArgs {
  filter?: InputMaybe<EmployeeFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListJobsArgs {
  filter?: InputMaybe<JobFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListMessagesArgs {
  filter?: InputMaybe<MessageFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListReservationSeriesArgs {
  filter?: InputMaybe<ReservationSeriesFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListReservationsArgs {
  filter?: InputMaybe<ReservationFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}


export interface QueryListWorkShiftsArgs {
  filter?: InputMaybe<WorkShiftFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
}

export type RacketType =
  | 'RACQUETBALL'
  | 'TENNIS';

export interface Reservation {
  __typename?: 'Reservation';
  account: Account;
  accountId: Scalars['ID']['output'];
  court: Court;
  courtId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  createdById: Scalars['ID']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  series?: Maybe<ReservationSeries>;
  seriesId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: ReservationStatus;
  updatedAt: Scalars['DateTime']['output'];
}

export interface ReservationFilter {
  courtId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<DateFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<DateFilter>;
  status?: InputMaybe<ReservationStatus>;
  updatedAt?: InputMaybe<DateFilter>;
}

export interface ReservationSeries {
  __typename?: 'ReservationSeries';
  account: Account;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Employee;
  createdById: Scalars['ID']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequency: FrequencyPattern;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reservations: ListReservationsResult;
  skipDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ReservationSeriesFilter {
  createdAt?: InputMaybe<DateFilter>;
  endDate?: InputMaybe<DateFilter>;
  frequencyType?: InputMaybe<FrequencyType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<StringFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<DateFilter>;
  updatedAt?: InputMaybe<DateFilter>;
}

export type ReservationStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'CONFIRMED'
  | 'PENDING';

export interface SaveAccountSettingsInput {
  businessHours: Array<BusinessHoursInput>;
  jobFinishedSmsTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}

export interface SetupPlanInput {
  accountId: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
}

export interface SignUpInput {
  companyName: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['Password']['input'];
  phone: Scalars['PhoneNumber']['input'];
}

export interface SignUpResult {
  __typename?: 'SignUpResult';
  accountId: Scalars['ID']['output'];
  billingSecret: Scalars['String']['output'];
}

export interface SortInput {
  field: Scalars['String']['input'];
  order: SortOrder;
}

export type SortOrder =
  | 'ASC'
  | 'DESC';

export interface StringFilter {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  isAnyOf?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}

export interface SubscribeToPlanInput {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  planId: Scalars['ID']['input'];
}

export interface Subscription {
  __typename?: 'Subscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  defaultPaymentMethod?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<SubscriptionDiscount>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<SubscriptionItems>;
  plan?: Maybe<SubscriptionPlan>;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
  trialStart?: Maybe<Scalars['DateTime']['output']>;
}

export interface SubscriptionDiscount {
  __typename?: 'SubscriptionDiscount';
  coupon?: Maybe<Coupon>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
}

export interface SubscriptionItem {
  __typename?: 'SubscriptionItem';
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  plan: SubscriptionPlan;
  price: SubscriptionPrice;
  quantity: Scalars['Int']['output'];
}

export interface SubscriptionItems {
  __typename?: 'SubscriptionItems';
  data: Array<SubscriptionItem>;
  totalCount: Scalars['Int']['output'];
}

export interface SubscriptionPlan {
  __typename?: 'SubscriptionPlan';
  amount: Scalars['Int']['output'];
  billingScheme: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['String']['output'];
  intervalCount?: Maybe<Scalars['Int']['output']>;
  product: Scalars['String']['output'];
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  usageType: Scalars['String']['output'];
}

export interface SubscriptionPrice {
  __typename?: 'SubscriptionPrice';
  billingScheme?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<PriceRecurringConfig>;
  type: Scalars['String']['output'];
  unitAmount?: Maybe<Scalars['Int']['output']>;
}

export interface UpdateAccountInput {
  businessHours?: InputMaybe<Array<BusinessHoursInput>>;
  id: Scalars['ID']['input'];
  jobFinishedSmsTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationsPhoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  phone: Scalars['PhoneNumber']['input'];
  status: AccountStatus;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UpdateCourtInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  coverage?: InputMaybe<CourtCoverage>;
  id: Scalars['ID']['input'];
  location: CourtLocationInput;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  surface?: InputMaybe<CourtSurface>;
}

export interface UpdateCustomerInput {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  memNumber?: InputMaybe<Scalars['String']['input']>;
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  ntrpRating?: InputMaybe<NtrpRating>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateEmployeeInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  role: EmployeeRole;
  status: EmployeeStatus;
}

export interface UpdateEmployeeSettingsInput {
  color?: InputMaybe<Scalars['Color']['input']>;
  email: Scalars['Email']['input'];
  id: Scalars['ID']['input'];
  preferences?: InputMaybe<Scalars['JSON']['input']>;
}

export interface UpdateJobInput {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishedById?: InputMaybe<Scalars['ID']['input']>;
  gauge?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  racket?: InputMaybe<Scalars['String']['input']>;
  racketType?: InputMaybe<RacketType>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<JobStatus>;
  stringName?: InputMaybe<Scalars['String']['input']>;
  tension?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateJobStatusInput {
  finishedById?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  sendNotification: Scalars['Boolean']['input'];
  status: JobStatus;
}

export interface UpdateJobsStatusInput {
  finishedById?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
  sendNotification: Scalars['Boolean']['input'];
  status: JobStatus;
}

export interface UpdateReservationInput {
  courtId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReservationStatus>;
}

export interface UpdateReservationSeriesInput {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<FrequencyPatternInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UpdateUserNotificationPreferencesInput {
  notificationTypesOptedOut?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface UpdateUserPassword {
  newPassword: Scalars['Password']['input'];
  userId: Scalars['ID']['input'];
}

export interface UpdateWorkShiftInput {
  employeeId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  status: WorkShiftStatus;
}

export interface UpdateWorkShiftsInput {
  employeeId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  ids: Array<Scalars['ID']['input']>;
  start: Scalars['DateTime']['input'];
  status: WorkShiftStatus;
}

export interface User {
  __typename?: 'User';
  attributes?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  role: UserRole;
  updatedAt: Scalars['DateTime']['output'];
}

export type UserRole =
  | 'ADMIN'
  | 'USER';

export interface WorkShift {
  __typename?: 'WorkShift';
  account: Account;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  employeeId: Scalars['ID']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  status: WorkShiftStatus;
  totalHours?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface WorkShiftFilter {
  createdAt?: InputMaybe<DateFilter>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<DateFilter>;
  q?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<DateFilter>;
  status?: InputMaybe<WorkShiftStatus>;
  updatedAt?: InputMaybe<DateFilter>;
}

export type WorkShiftStatus =
  | 'CLOCKED_IN'
  | 'SCHEDULED'
  | 'WORKED';

export type AccountFragment = { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', getAccount?: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, employees: { __typename?: 'ListEmployeesResult', total: number, data: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } | null };

export type GetAccountSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountSummaryQuery = { __typename?: 'Query', accountSummary: { __typename?: 'AccountSummary', unfinishedJobs: number, jobsByMonth: Array<{ __typename?: 'MonthJobCount', date: string, jobs: number }> } };

export type GetMyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAccountQuery = { __typename?: 'Query', myAccount?: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } | null };

export type GetMyAccountBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAccountBillingInfoQuery = { __typename?: 'Query', myAccount?: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } | null };

export type GetAccountsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAccountsQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null }> };

export type ListAccountsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<AccountFilter>;
}>;


export type ListAccountsQuery = { __typename?: 'Query', listAccounts: { __typename?: 'ListAccountsResult', total: number, data: Array<{ __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type SaveAccountSettingsMutationVariables = Exact<{
  input: SaveAccountSettingsInput;
}>;


export type SaveAccountSettingsMutation = { __typename?: 'Mutation', saveAccountSettings: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type CreateDemoAccountMutationVariables = Exact<{
  input?: InputMaybe<CreateDemoAccountInput>;
}>;


export type CreateDemoAccountMutation = { __typename?: 'Mutation', createDemoAccount: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'SignUpResult', accountId: string, billingSecret: string } };

export type SetupPlanMutationVariables = Exact<{
  input: SetupPlanInput;
}>;


export type SetupPlanMutation = { __typename?: 'Mutation', setupPlan: boolean };

export type ConfirmSignUpMutationVariables = Exact<{
  input: ConfirmSignUpInput;
}>;


export type ConfirmSignUpMutation = { __typename?: 'Mutation', confirmSignUp: boolean };

export type SubscriptionPlanFragment = { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null };

export type SubscriptionPriceFragment = { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null };

export type SubscriptionFragment = { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null };

export type BillingInfoFragment = { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null };

export type PlanFragment = { __typename?: 'Plan', id: string, name: string, description: string, metadata?: object | null, order: number, prices: Array<{ __typename?: 'PlanPrice', id: string, billingInterval: BillingInterval, amount: number, currency: string, metadata?: object | null }>, features: Array<{ __typename?: 'PlanFeature', id: string, name: string, fullDescription: string, shortDescription: string, key: string }> };

export type ListPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPlansQuery = { __typename?: 'Query', listPlans: Array<{ __typename?: 'Plan', id: string, name: string, description: string, metadata?: object | null, order: number, prices: Array<{ __typename?: 'PlanPrice', id: string, billingInterval: BillingInterval, amount: number, currency: string, metadata?: object | null }>, features: Array<{ __typename?: 'PlanFeature', id: string, name: string, fullDescription: string, shortDescription: string, key: string }> }> };

export type SubscribeToPlanMutationVariables = Exact<{
  input: SubscribeToPlanInput;
}>;


export type SubscribeToPlanMutation = { __typename?: 'Mutation', subscribeToPlan: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscription;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } };

export type CourtFragment = { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null };

export type GetCourtQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourtQuery = { __typename?: 'Query', getCourt?: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null } | null };

export type GetCourtsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCourtsQuery = { __typename?: 'Query', getCourts: Array<{ __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null }> };

export type ListCourtsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<CourtFilter>;
}>;


export type ListCourtsQuery = { __typename?: 'Query', listCourts: { __typename?: 'ListCourtsResult', total: number, data: Array<{ __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateCourtMutationVariables = Exact<{
  input: CreateCourtInput;
}>;


export type CreateCourtMutation = { __typename?: 'Mutation', createCourt: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null } };

export type UpdateCourtMutationVariables = Exact<{
  input: UpdateCourtInput;
}>;


export type UpdateCourtMutation = { __typename?: 'Mutation', updateCourt: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null } };

export type DeleteCourtMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCourtMutation = { __typename?: 'Mutation', deleteCourt: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null } };

export type DeleteCourtsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCourtsMutation = { __typename?: 'Mutation', deleteCourts?: Array<{ __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null, order?: number | null, createdAt: string, updatedAt: string, accountId: string, reservationsToday?: number | null, location: { __typename?: 'CourtLocation', x: number, y: number, rotation: number }, nextReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string } | null }> | null };

export type CustomerFragment = { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string };

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<JobFilter>;
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string, jobs: { __typename?: 'ListJobsResult', total: number, data: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type GetCustomersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCustomersQuery = { __typename?: 'Query', getCustomers: Array<{ __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string }> };

export type ListCustomersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<CustomerFilter>;
}>;


export type ListCustomersQuery = { __typename?: 'Query', listCustomers: { __typename?: 'ListCustomersResult', total: number, data: Array<{ __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } };

export type DeleteCustomersMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCustomersMutation = { __typename?: 'Mutation', deleteCustomers?: Array<{ __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string }> | null };

export type EmployeeFragment = { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  jobsPagination?: InputMaybe<PaginationInput>;
  jobsSort?: InputMaybe<SortInput>;
  jobsFilter?: InputMaybe<JobFilter>;
  workshiftsPagination?: InputMaybe<PaginationInput>;
  workshiftsSort?: InputMaybe<SortInput>;
  workshiftsFilter?: InputMaybe<WorkShiftFilter>;
}>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null, jobsFinished: { __typename?: 'ListJobsResult', total: number, data: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, workShifts: { __typename?: 'ListWorkShiftsResult', total: number, data: Array<{ __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, messagesSent: { __typename?: 'ListMessagesResult', total: number, data: Array<{ __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null, account: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null } } };

export type GetEmployeesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null }> };

export type ListEmployeesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<EmployeeFilter>;
}>;


export type ListEmployeesQuery = { __typename?: 'Query', listEmployees: { __typename?: 'ListEmployeesResult', total: number, data: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type InviteEmployeeMutationVariables = Exact<{
  input: InviteEmployeeInput;
}>;


export type InviteEmployeeMutation = { __typename?: 'Mutation', inviteEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type DeleteEmployeesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteEmployeesMutation = { __typename?: 'Mutation', deleteEmployees?: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null }> | null };

export type DeactivateEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateEmployeeMutation = { __typename?: 'Mutation', deactivateEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type ReactivateEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReactivateEmployeeMutation = { __typename?: 'Mutation', reactivateEmployee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type ResetEmployeePasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newPassword: Scalars['Password']['input'];
}>;


export type ResetEmployeePasswordMutation = { __typename?: 'Mutation', resetEmployeePassword: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type UpdateEmployeeSettingsMutationVariables = Exact<{
  input: UpdateEmployeeSettingsInput;
}>;


export type UpdateEmployeeSettingsMutation = { __typename?: 'Mutation', updateEmployeeSettings: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, user?: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } | null } };

export type JobFragment = { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string };

export type JobWithRelationsFragment = { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', getJob?: { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null } | null };

export type UpdateJobStatusMutationVariables = Exact<{
  input: UpdateJobStatusInput;
}>;


export type UpdateJobStatusMutation = { __typename?: 'Mutation', updateJobStatus: { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null } };

export type UpdateJobsStatusMutationVariables = Exact<{
  input: UpdateJobsStatusInput;
}>;


export type UpdateJobsStatusMutation = { __typename?: 'Mutation', updateJobsStatus: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }> };

export type GetJobsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetJobsQuery = { __typename?: 'Query', getJobs: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }> };

export type ListJobsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<JobFilter>;
}>;


export type ListJobsQuery = { __typename?: 'Query', listJobs: { __typename?: 'ListJobsResult', total: number, data: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null } };

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInput;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null } };

export type DeleteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null } };

export type DeleteJobsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteJobsMutation = { __typename?: 'Mutation', deleteJobs?: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, finishedBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }> | null };

export type MessageFragment = { __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string };

export type MessageWithRelationsFragment = { __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, account: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null }, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null, sentBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null };

export type GetMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMessageQuery = { __typename?: 'Query', getMessage?: { __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, account: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null }, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null, sentBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null } | null };

export type GetMessagesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetMessagesQuery = { __typename?: 'Query', getMessages: Array<{ __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, account: { __typename?: 'Account', id: string, name: string, phone: string, status: AccountStatus, notificationsPhoneNumber?: string | null, jobFinishedSmsTemplate?: string | null, trialEndDate?: string | null, createdAt: string, updatedAt: string, businessHours?: Array<{ __typename?: 'BusinessHours', daysOfWeek: Array<number>, startTime: string, endTime: string }> | null, billingInfo?: { __typename?: 'BillingInfo', customer?: { __typename?: 'BillingCustomerInfo', id: string, email: string, name?: string | null, phone?: string | null, address?: object | null, delinquent: boolean, invoiceSettings: { __typename?: 'InvoiceSettings', defaultPaymentMethod?: string | null } } | null, currentSubscription?: { __typename?: 'Subscription', id: string, status: string, startDate: string, currentPeriodStart: string, currentPeriodEnd: string, trialStart?: string | null, trialEnd?: string | null, endedAt?: string | null, cancelAtPeriodEnd: boolean, canceledAt?: string | null, cancelReason?: string | null, created: string, currency: string, defaultPaymentMethod?: string | null, discount?: { __typename?: 'SubscriptionDiscount', id: string, start?: string | null, end?: string | null, coupon?: { __typename?: 'Coupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null, duration: string, durationInMonths?: number | null, maxRedemptions?: number | null, redeemBy?: string | null } | null } | null, plan?: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null } | null, items?: { __typename?: 'SubscriptionItems', totalCount: number, data: Array<{ __typename?: 'SubscriptionItem', id: string, quantity: number, currentPeriodStart: string, currentPeriodEnd: string, plan: { __typename?: 'SubscriptionPlan', id: string, product: string, amount: number, currency: string, interval: string, usageType: string, billingScheme: string, intervalCount?: number | null, trialPeriodDays?: number | null }, price: { __typename?: 'SubscriptionPrice', id: string, type: string, currency: string, nickname?: string | null, lookupKey?: string | null, unitAmount?: number | null, billingScheme?: string | null, recurring?: { __typename?: 'PriceRecurringConfig', interval: string, intervalCount?: number | null, usageType: string, trialPeriodDays?: number | null } | null } }> } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: string, created: string, billingDetails?: object | null, card?: { __typename?: 'Card', brand: string, lastFour: string, expYear: number, expMonth: number, displayBrand: string, country: string, funding: string } | null }> | null } | null }, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null, sentBy?: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } | null }> };

export type ListMessagesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<MessageFilter>;
}>;


export type ListMessagesQuery = { __typename?: 'Query', listMessages: { __typename?: 'ListMessagesResult', total: number, data: Array<{ __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, externalId: string, fromPhoneNumber: string, toPhoneNumber: string, body: string, sentById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string } };

export type GetPingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPingQuery = { __typename?: 'Query', ping?: boolean | null };

export type GetPongMutationVariables = Exact<{ [key: string]: never; }>;


export type GetPongMutation = { __typename?: 'Mutation', pong?: boolean | null };

export type PayrollReportQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type PayrollReportQuery = { __typename?: 'Query', listEmployees: { __typename?: 'ListEmployeesResult', data: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string>, jobsFinished: { __typename?: 'ListJobsResult', data: Array<{ __typename?: 'Job', id: string, name?: string | null, stringName?: string | null, racket?: string | null, racketType: RacketType, tension?: string | null, gauge?: string | null, status: JobStatus, receivedAt?: string | null, finishedAt?: string | null, paidAt?: string | null, finishedById?: string | null, customerId?: string | null, accountId: string, createdAt: string, updatedAt: string, customer?: { __typename?: 'Customer', id: string, memNumber?: string | null, lastName?: string | null, firstName?: string | null, middleInitial?: string | null, email?: string | null, address?: string | null, address2?: string | null, city?: string | null, zip?: string | null, homePhone?: string | null, cellPhone?: string | null, workPhone?: string | null, dateOfBirth?: string | null, gender?: Gender | null, ntrpRating?: NtrpRating | null, createdAt: string, updatedAt: string, accountId: string } | null }> }, workShifts: { __typename?: 'ListWorkShiftsResult', data: Array<{ __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } }> } }> } };

export type ReservationFragment = { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null };

export type ReservationSeriesFragment = { __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } };

export type ListReservationsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<ReservationFilter>;
}>;


export type ListReservationsQuery = { __typename?: 'Query', listReservations: { __typename?: 'ListReservationsResult', total: number, data: Array<{ __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetReservationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReservationQuery = { __typename?: 'Query', getReservation?: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null } | null };

export type ListReservationSeriesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<ReservationSeriesFilter>;
}>;


export type ListReservationSeriesQuery = { __typename?: 'Query', listReservationSeries: { __typename?: 'ListReservationSeriesResult', total: number, data: Array<{ __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, reservations: { __typename?: 'ListReservationsResult', total: number, data: Array<{ __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetReservationSeriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReservationSeriesQuery = { __typename?: 'Query', getReservationSeries?: { __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, reservations: { __typename?: 'ListReservationsResult', total: number, data: Array<{ __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } }, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } } | null };

export type GetReservationSeriesListQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetReservationSeriesListQuery = { __typename?: 'Query', getReservationSeriesList: Array<{ __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } }> };

export type CreateReservationMutationVariables = Exact<{
  input: CreateReservationInput;
}>;


export type CreateReservationMutation = { __typename?: 'Mutation', createReservation: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null } };

export type UpdateReservationMutationVariables = Exact<{
  input: UpdateReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation: { __typename?: 'Reservation', id: string, startTime: string, endTime: string, status: ReservationStatus, notes?: string | null, createdAt: string, updatedAt: string, courtId: string, customerId?: string | null, createdById: string, seriesId?: string | null, court: { __typename?: 'Court', id: string, name: string, surface?: CourtSurface | null, coverage?: CourtCoverage | null, color?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string }, series?: { __typename?: 'ReservationSeries', id: string, name?: string | null, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, description?: string | null } } | null } };

export type DeleteReservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReservationMutation = { __typename?: 'Mutation', deleteReservation: { __typename?: 'Reservation', id: string } };

export type CreateReservationSeriesMutationVariables = Exact<{
  input: CreateReservationSeriesInput;
}>;


export type CreateReservationSeriesMutation = { __typename?: 'Mutation', createReservationSeries: { __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } } };

export type UpdateReservationSeriesMutationVariables = Exact<{
  input: UpdateReservationSeriesInput;
}>;


export type UpdateReservationSeriesMutation = { __typename?: 'Mutation', updateReservationSeries: { __typename?: 'ReservationSeries', id: string, name?: string | null, startDate: string, endDate?: string | null, skipDates?: Array<string> | null, createdAt: string, updatedAt: string, customerId?: string | null, createdById: string, frequency: { __typename?: 'FrequencyPattern', type: FrequencyType, interval?: number | null, daysOfWeek?: Array<number | null> | null, weekOfMonth?: number | null, dayOfMonth?: number | null, description?: string | null }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, cellPhone?: string | null } | null, createdBy: { __typename?: 'Employee', id: string, firstName: string, lastName: string } } };

export type DeleteReservationSeriesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReservationSeriesMutation = { __typename?: 'Mutation', deleteReservationSeries: { __typename?: 'ReservationSeries', id: string } };

export type DeleteReservationSeriesListMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteReservationSeriesListMutation = { __typename?: 'Mutation', deleteReservationSeriesList?: Array<{ __typename?: 'ReservationSeries', id: string }> | null };

export type UserFragment = { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string };

export type ChangeUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInput;
}>;


export type ChangeUserPasswordMutation = { __typename?: 'Mutation', changeUserPassword: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } };

export type UpdateUserNotificationPreferencesMutationVariables = Exact<{
  input: UpdateUserNotificationPreferencesInput;
}>;


export type UpdateUserNotificationPreferencesMutation = { __typename?: 'Mutation', updateUserNotificationPreferences: { __typename?: 'User', id: string, email: string, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, isActive: boolean, role: UserRole, attributes?: object | null, createdAt: string, updatedAt: string } };

export type WorkShiftFragment = { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } };

export type GetWorkShiftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkShiftQuery = { __typename?: 'Query', getWorkShift?: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } | null };

export type GetActiveWorkShiftQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetActiveWorkShiftQuery = { __typename?: 'Query', getActiveWorkShift?: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } | null };

export type GetWorkShiftsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetWorkShiftsQuery = { __typename?: 'Query', getWorkShifts: Array<{ __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } }> };

export type ListWorkShiftsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<WorkShiftFilter>;
}>;


export type ListWorkShiftsQuery = { __typename?: 'Query', listWorkShifts: { __typename?: 'ListWorkShiftsResult', total: number, data: Array<{ __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateWorkShiftMutationVariables = Exact<{
  input: CreateWorkShiftInput;
}>;


export type CreateWorkShiftMutation = { __typename?: 'Mutation', createWorkShift: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } };

export type UpdateWorkShiftMutationVariables = Exact<{
  input: UpdateWorkShiftInput;
}>;


export type UpdateWorkShiftMutation = { __typename?: 'Mutation', updateWorkShift: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } };

export type DeleteWorkShiftMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkShiftMutation = { __typename?: 'Mutation', deleteWorkShift: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } };

export type DeleteWorkShiftsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteWorkShiftsMutation = { __typename?: 'Mutation', deleteWorkShifts?: Array<{ __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } }> | null };

export type ClockInMutationVariables = Exact<{
  input: ClockInOutInput;
}>;


export type ClockInMutation = { __typename?: 'Mutation', clockIn: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } };

export type ClockOutMutationVariables = Exact<{
  input: ClockInOutInput;
}>;


export type ClockOutMutation = { __typename?: 'Mutation', clockOut: { __typename?: 'WorkShift', id: string, status: WorkShiftStatus, start: string, end?: string | null, employeeId: string, accountId: string, createdAt: string, updatedAt: string, totalHours?: number | null, employee: { __typename?: 'Employee', id: string, firstName: string, lastName: string, email: string, status: EmployeeStatus, role: EmployeeRole, color?: string | null, preferences?: object | null, userId?: string | null, accountId: string, createdAt: string, updatedAt: string, permissions: Array<string> } } };

export const PlanFragmentDoc = gql`
    fragment Plan on Plan {
  id
  name
  description
  prices {
    id
    billingInterval
    amount
    currency
    metadata
  }
  features {
    id
    name
    fullDescription
    shortDescription
    key
  }
  metadata
  order
}
    `;
export const CourtFragmentDoc = gql`
    fragment Court on Court {
  id
  name
  location {
    x
    y
    rotation
  }
  surface
  coverage
  color
  order
  createdAt
  updatedAt
  accountId
  reservationsToday
  nextReservation {
    id
    startTime
    endTime
    status
    notes
    createdAt
    updatedAt
    courtId
  }
}
    `;
export const JobFragmentDoc = gql`
    fragment Job on Job {
  id
  name
  stringName
  racket
  racketType
  tension
  gauge
  status
  receivedAt
  finishedAt
  paidAt
  finishedById
  customerId
  accountId
  createdAt
  updatedAt
}
    `;
export const EmployeeFragmentDoc = gql`
    fragment Employee on Employee {
  id
  firstName
  lastName
  email
  status
  role
  color
  preferences
  userId
  accountId
  createdAt
  updatedAt
  permissions
}
    `;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  id
  memNumber
  lastName
  firstName
  middleInitial
  email
  address
  address2
  city
  zip
  homePhone
  cellPhone
  workPhone
  dateOfBirth
  gender
  ntrpRating
  createdAt
  updatedAt
  accountId
}
    `;
export const JobWithRelationsFragmentDoc = gql`
    fragment JobWithRelations on Job {
  ...Job
  finishedBy {
    ...Employee
  }
  customer {
    ...Customer
  }
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  externalId
  fromPhoneNumber
  toPhoneNumber
  body
  sentById
  customerId
  accountId
  createdAt
  updatedAt
}
    `;
export const SubscriptionPlanFragmentDoc = gql`
    fragment SubscriptionPlan on SubscriptionPlan {
  id
  product
  amount
  currency
  interval
  usageType
  billingScheme
  intervalCount
  trialPeriodDays
}
    `;
export const SubscriptionPriceFragmentDoc = gql`
    fragment SubscriptionPrice on SubscriptionPrice {
  id
  type
  currency
  nickname
  recurring {
    interval
    intervalCount
    usageType
    trialPeriodDays
  }
  lookupKey
  unitAmount
  billingScheme
}
    `;
export const SubscriptionFragmentDoc = gql`
    fragment Subscription on Subscription {
  id
  status
  startDate
  currentPeriodStart
  currentPeriodEnd
  trialStart
  trialEnd
  endedAt
  cancelAtPeriodEnd
  canceledAt
  cancelReason
  created
  currency
  defaultPaymentMethod
  discount {
    id
    coupon {
      id
      name
      amountOff
      percentOff
      duration
      durationInMonths
      maxRedemptions
      redeemBy
    }
    start
    end
  }
  plan {
    ...SubscriptionPlan
  }
  items {
    totalCount
    data {
      id
      quantity
      currentPeriodStart
      currentPeriodEnd
      plan {
        ...SubscriptionPlan
      }
      price {
        ...SubscriptionPrice
      }
    }
  }
}
    `;
export const BillingInfoFragmentDoc = gql`
    fragment BillingInfo on BillingInfo {
  customer {
    id
    email
    name
    phone
    address
    delinquent
    invoiceSettings {
      defaultPaymentMethod
    }
  }
  currentSubscription {
    ...Subscription
  }
  paymentMethods {
    id
    type
    created
    card {
      brand
      lastFour
      expYear
      expMonth
      displayBrand
      country
      funding
    }
    billingDetails
  }
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  name
  phone
  status
  notificationsPhoneNumber
  jobFinishedSmsTemplate
  businessHours {
    daysOfWeek
    startTime
    endTime
  }
  trialEndDate
  createdAt
  updatedAt
  billingInfo {
    ...BillingInfo
  }
}
    `;
export const MessageWithRelationsFragmentDoc = gql`
    fragment MessageWithRelations on Message {
  ...Message
  account {
    ...Account
  }
  customer {
    ...Customer
  }
  sentBy {
    ...Employee
  }
}
    `;
export const ReservationFragmentDoc = gql`
    fragment Reservation on Reservation {
  id
  startTime
  endTime
  status
  notes
  createdAt
  updatedAt
  courtId
  court {
    id
    name
    surface
    coverage
    color
  }
  customerId
  customer {
    id
    firstName
    lastName
    email
    cellPhone
  }
  createdById
  createdBy {
    id
    firstName
    lastName
  }
  seriesId
  series {
    id
    name
    frequency {
      type
      description
    }
  }
}
    `;
export const ReservationSeriesFragmentDoc = gql`
    fragment ReservationSeries on ReservationSeries {
  id
  name
  startDate
  endDate
  frequency {
    type
    interval
    daysOfWeek
    weekOfMonth
    dayOfMonth
    description
  }
  skipDates
  createdAt
  updatedAt
  customerId
  customer {
    id
    firstName
    lastName
    email
    cellPhone
  }
  createdById
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  emailVerified
  phoneNumber
  phoneNumberVerified
  isActive
  role
  attributes
  createdAt
  updatedAt
}
    `;
export const WorkShiftFragmentDoc = gql`
    fragment WorkShift on WorkShift {
  id
  status
  start
  end
  employeeId
  employee {
    ...Employee
  }
  accountId
  createdAt
  updatedAt
  totalHours
}
    `;
export const GetAccountDocument = gql`
    query GetAccount($id: ID!) {
  getAccount(id: $id) {
    ...Account
    employees(pagination: {perPage: 100}) {
      data {
        ...Employee
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
// @ts-ignore
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery | undefined, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountSummaryDocument = gql`
    query GetAccountSummary {
  accountSummary {
    unfinishedJobs
    jobsByMonth {
      date
      jobs
    }
  }
}
    `;

/**
 * __useGetAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGetAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>(GetAccountSummaryDocument, options);
      }
export function useGetAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>(GetAccountSummaryDocument, options);
        }
// @ts-ignore
export function useGetAccountSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>;
export function useGetAccountSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountSummaryQuery | undefined, GetAccountSummaryQueryVariables>;
export function useGetAccountSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>(GetAccountSummaryDocument, options);
        }
export type GetAccountSummaryQueryHookResult = ReturnType<typeof useGetAccountSummaryQuery>;
export type GetAccountSummaryLazyQueryHookResult = ReturnType<typeof useGetAccountSummaryLazyQuery>;
export type GetAccountSummarySuspenseQueryHookResult = ReturnType<typeof useGetAccountSummarySuspenseQuery>;
export type GetAccountSummaryQueryResult = Apollo.QueryResult<GetAccountSummaryQuery, GetAccountSummaryQueryVariables>;
export const GetMyAccountDocument = gql`
    query GetMyAccount {
  myAccount {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;

/**
 * __useGetMyAccountQuery__
 *
 * To run a query within a React component, call `useGetMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAccountQuery, GetMyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAccountQuery, GetMyAccountQueryVariables>(GetMyAccountDocument, options);
      }
export function useGetMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAccountQuery, GetMyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAccountQuery, GetMyAccountQueryVariables>(GetMyAccountDocument, options);
        }
// @ts-ignore
export function useGetMyAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAccountQuery, GetMyAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAccountQuery, GetMyAccountQueryVariables>;
export function useGetMyAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAccountQuery, GetMyAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAccountQuery | undefined, GetMyAccountQueryVariables>;
export function useGetMyAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAccountQuery, GetMyAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAccountQuery, GetMyAccountQueryVariables>(GetMyAccountDocument, options);
        }
export type GetMyAccountQueryHookResult = ReturnType<typeof useGetMyAccountQuery>;
export type GetMyAccountLazyQueryHookResult = ReturnType<typeof useGetMyAccountLazyQuery>;
export type GetMyAccountSuspenseQueryHookResult = ReturnType<typeof useGetMyAccountSuspenseQuery>;
export type GetMyAccountQueryResult = Apollo.QueryResult<GetMyAccountQuery, GetMyAccountQueryVariables>;
export const GetMyAccountBillingInfoDocument = gql`
    query GetMyAccountBillingInfo {
  myAccount {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;

/**
 * __useGetMyAccountBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetMyAccountBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAccountBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAccountBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAccountBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>(GetMyAccountBillingInfoDocument, options);
      }
export function useGetMyAccountBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>(GetMyAccountBillingInfoDocument, options);
        }
// @ts-ignore
export function useGetMyAccountBillingInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>;
export function useGetMyAccountBillingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAccountBillingInfoQuery | undefined, GetMyAccountBillingInfoQueryVariables>;
export function useGetMyAccountBillingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>(GetMyAccountBillingInfoDocument, options);
        }
export type GetMyAccountBillingInfoQueryHookResult = ReturnType<typeof useGetMyAccountBillingInfoQuery>;
export type GetMyAccountBillingInfoLazyQueryHookResult = ReturnType<typeof useGetMyAccountBillingInfoLazyQuery>;
export type GetMyAccountBillingInfoSuspenseQueryHookResult = ReturnType<typeof useGetMyAccountBillingInfoSuspenseQuery>;
export type GetMyAccountBillingInfoQueryResult = Apollo.QueryResult<GetMyAccountBillingInfoQuery, GetMyAccountBillingInfoQueryVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts($ids: [ID!]!) {
  getAccounts(ids: $ids) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables> & ({ variables: GetAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery | undefined, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const ListAccountsDocument = gql`
    query ListAccounts($pagination: PaginationInput, $sort: SortInput, $filter: AccountFilter) {
  listAccounts(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Account
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;

/**
 * __useListAccountsQuery__
 *
 * To run a query within a React component, call `useListAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
      }
export function useListAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
// @ts-ignore
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountsQuery | undefined, ListAccountsQueryVariables>;
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
export type ListAccountsQueryHookResult = ReturnType<typeof useListAccountsQuery>;
export type ListAccountsLazyQueryHookResult = ReturnType<typeof useListAccountsLazyQuery>;
export type ListAccountsSuspenseQueryHookResult = ReturnType<typeof useListAccountsSuspenseQuery>;
export type ListAccountsQueryResult = Apollo.QueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($id: ID!) {
  deleteAccount(id: $id) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const SaveAccountSettingsDocument = gql`
    mutation SaveAccountSettings($input: SaveAccountSettingsInput!) {
  saveAccountSettings(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type SaveAccountSettingsMutationFn = Apollo.MutationFunction<SaveAccountSettingsMutation, SaveAccountSettingsMutationVariables>;

/**
 * __useSaveAccountSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccountSettingsMutation, { data, loading, error }] = useSaveAccountSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAccountSettingsMutation, SaveAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAccountSettingsMutation, SaveAccountSettingsMutationVariables>(SaveAccountSettingsDocument, options);
      }
export type SaveAccountSettingsMutationHookResult = ReturnType<typeof useSaveAccountSettingsMutation>;
export type SaveAccountSettingsMutationResult = Apollo.MutationResult<SaveAccountSettingsMutation>;
export type SaveAccountSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAccountSettingsMutation, SaveAccountSettingsMutationVariables>;
export const CreateDemoAccountDocument = gql`
    mutation CreateDemoAccount($input: CreateDemoAccountInput) {
  createDemoAccount(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type CreateDemoAccountMutationFn = Apollo.MutationFunction<CreateDemoAccountMutation, CreateDemoAccountMutationVariables>;

/**
 * __useCreateDemoAccountMutation__
 *
 * To run a mutation, you first call `useCreateDemoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemoAccountMutation, { data, loading, error }] = useCreateDemoAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDemoAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDemoAccountMutation, CreateDemoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDemoAccountMutation, CreateDemoAccountMutationVariables>(CreateDemoAccountDocument, options);
      }
export type CreateDemoAccountMutationHookResult = ReturnType<typeof useCreateDemoAccountMutation>;
export type CreateDemoAccountMutationResult = Apollo.MutationResult<CreateDemoAccountMutation>;
export type CreateDemoAccountMutationOptions = Apollo.BaseMutationOptions<CreateDemoAccountMutation, CreateDemoAccountMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    accountId
    billingSecret
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SetupPlanDocument = gql`
    mutation SetupPlan($input: SetupPlanInput!) {
  setupPlan(input: $input)
}
    `;
export type SetupPlanMutationFn = Apollo.MutationFunction<SetupPlanMutation, SetupPlanMutationVariables>;

/**
 * __useSetupPlanMutation__
 *
 * To run a mutation, you first call `useSetupPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupPlanMutation, { data, loading, error }] = useSetupPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupPlanMutation(baseOptions?: Apollo.MutationHookOptions<SetupPlanMutation, SetupPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupPlanMutation, SetupPlanMutationVariables>(SetupPlanDocument, options);
      }
export type SetupPlanMutationHookResult = ReturnType<typeof useSetupPlanMutation>;
export type SetupPlanMutationResult = Apollo.MutationResult<SetupPlanMutation>;
export type SetupPlanMutationOptions = Apollo.BaseMutationOptions<SetupPlanMutation, SetupPlanMutationVariables>;
export const ConfirmSignUpDocument = gql`
    mutation ConfirmSignUp($input: ConfirmSignUpInput!) {
  confirmSignUp(input: $input)
}
    `;
export type ConfirmSignUpMutationFn = Apollo.MutationFunction<ConfirmSignUpMutation, ConfirmSignUpMutationVariables>;

/**
 * __useConfirmSignUpMutation__
 *
 * To run a mutation, you first call `useConfirmSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSignUpMutation, { data, loading, error }] = useConfirmSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSignUpMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSignUpMutation, ConfirmSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSignUpMutation, ConfirmSignUpMutationVariables>(ConfirmSignUpDocument, options);
      }
export type ConfirmSignUpMutationHookResult = ReturnType<typeof useConfirmSignUpMutation>;
export type ConfirmSignUpMutationResult = Apollo.MutationResult<ConfirmSignUpMutation>;
export type ConfirmSignUpMutationOptions = Apollo.BaseMutationOptions<ConfirmSignUpMutation, ConfirmSignUpMutationVariables>;
export const ListPlansDocument = gql`
    query ListPlans {
  listPlans {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;

/**
 * __useListPlansQuery__
 *
 * To run a query within a React component, call `useListPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPlansQuery(baseOptions?: Apollo.QueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
      }
export function useListPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
        }
// @ts-ignore
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPlansQuery, ListPlansQueryVariables>;
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPlansQuery | undefined, ListPlansQueryVariables>;
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
        }
export type ListPlansQueryHookResult = ReturnType<typeof useListPlansQuery>;
export type ListPlansLazyQueryHookResult = ReturnType<typeof useListPlansLazyQuery>;
export type ListPlansSuspenseQueryHookResult = ReturnType<typeof useListPlansSuspenseQuery>;
export type ListPlansQueryResult = Apollo.QueryResult<ListPlansQuery, ListPlansQueryVariables>;
export const SubscribeToPlanDocument = gql`
    mutation SubscribeToPlan($input: SubscribeToPlanInput!) {
  subscribeToPlan(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type SubscribeToPlanMutationFn = Apollo.MutationFunction<SubscribeToPlanMutation, SubscribeToPlanMutationVariables>;

/**
 * __useSubscribeToPlanMutation__
 *
 * To run a mutation, you first call `useSubscribeToPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPlanMutation, { data, loading, error }] = useSubscribeToPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToPlanMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToPlanMutation, SubscribeToPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToPlanMutation, SubscribeToPlanMutationVariables>(SubscribeToPlanDocument, options);
      }
export type SubscribeToPlanMutationHookResult = ReturnType<typeof useSubscribeToPlanMutation>;
export type SubscribeToPlanMutationResult = Apollo.MutationResult<SubscribeToPlanMutation>;
export type SubscribeToPlanMutationOptions = Apollo.BaseMutationOptions<SubscribeToPlanMutation, SubscribeToPlanMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscription!) {
  cancelSubscription(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation SetDefaultPaymentMethod($paymentMethodId: ID!) {
  setDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($paymentMethodId: ID!) {
  removePaymentMethod(paymentMethodId: $paymentMethodId) {
    ...Account
  }
}
    ${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const GetCourtDocument = gql`
    query GetCourt($id: ID!) {
  getCourt(id: $id) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;

/**
 * __useGetCourtQuery__
 *
 * To run a query within a React component, call `useGetCourtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourtQuery(baseOptions: Apollo.QueryHookOptions<GetCourtQuery, GetCourtQueryVariables> & ({ variables: GetCourtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtQuery, GetCourtQueryVariables>(GetCourtDocument, options);
      }
export function useGetCourtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtQuery, GetCourtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtQuery, GetCourtQueryVariables>(GetCourtDocument, options);
        }
// @ts-ignore
export function useGetCourtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourtQuery, GetCourtQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourtQuery, GetCourtQueryVariables>;
export function useGetCourtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourtQuery, GetCourtQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourtQuery | undefined, GetCourtQueryVariables>;
export function useGetCourtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourtQuery, GetCourtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourtQuery, GetCourtQueryVariables>(GetCourtDocument, options);
        }
export type GetCourtQueryHookResult = ReturnType<typeof useGetCourtQuery>;
export type GetCourtLazyQueryHookResult = ReturnType<typeof useGetCourtLazyQuery>;
export type GetCourtSuspenseQueryHookResult = ReturnType<typeof useGetCourtSuspenseQuery>;
export type GetCourtQueryResult = Apollo.QueryResult<GetCourtQuery, GetCourtQueryVariables>;
export const GetCourtsDocument = gql`
    query GetCourts($ids: [ID!]!) {
  getCourts(ids: $ids) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;

/**
 * __useGetCourtsQuery__
 *
 * To run a query within a React component, call `useGetCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourtsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCourtsQuery(baseOptions: Apollo.QueryHookOptions<GetCourtsQuery, GetCourtsQueryVariables> & ({ variables: GetCourtsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourtsQuery, GetCourtsQueryVariables>(GetCourtsDocument, options);
      }
export function useGetCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourtsQuery, GetCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourtsQuery, GetCourtsQueryVariables>(GetCourtsDocument, options);
        }
// @ts-ignore
export function useGetCourtsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourtsQuery, GetCourtsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourtsQuery, GetCourtsQueryVariables>;
export function useGetCourtsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourtsQuery, GetCourtsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourtsQuery | undefined, GetCourtsQueryVariables>;
export function useGetCourtsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourtsQuery, GetCourtsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourtsQuery, GetCourtsQueryVariables>(GetCourtsDocument, options);
        }
export type GetCourtsQueryHookResult = ReturnType<typeof useGetCourtsQuery>;
export type GetCourtsLazyQueryHookResult = ReturnType<typeof useGetCourtsLazyQuery>;
export type GetCourtsSuspenseQueryHookResult = ReturnType<typeof useGetCourtsSuspenseQuery>;
export type GetCourtsQueryResult = Apollo.QueryResult<GetCourtsQuery, GetCourtsQueryVariables>;
export const ListCourtsDocument = gql`
    query ListCourts($pagination: PaginationInput, $sort: SortInput, $filter: CourtFilter) {
  listCourts(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Court
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CourtFragmentDoc}`;

/**
 * __useListCourtsQuery__
 *
 * To run a query within a React component, call `useListCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCourtsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListCourtsQuery(baseOptions?: Apollo.QueryHookOptions<ListCourtsQuery, ListCourtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCourtsQuery, ListCourtsQueryVariables>(ListCourtsDocument, options);
      }
export function useListCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCourtsQuery, ListCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCourtsQuery, ListCourtsQueryVariables>(ListCourtsDocument, options);
        }
// @ts-ignore
export function useListCourtsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCourtsQuery, ListCourtsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCourtsQuery, ListCourtsQueryVariables>;
export function useListCourtsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCourtsQuery, ListCourtsQueryVariables>): Apollo.UseSuspenseQueryResult<ListCourtsQuery | undefined, ListCourtsQueryVariables>;
export function useListCourtsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCourtsQuery, ListCourtsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCourtsQuery, ListCourtsQueryVariables>(ListCourtsDocument, options);
        }
export type ListCourtsQueryHookResult = ReturnType<typeof useListCourtsQuery>;
export type ListCourtsLazyQueryHookResult = ReturnType<typeof useListCourtsLazyQuery>;
export type ListCourtsSuspenseQueryHookResult = ReturnType<typeof useListCourtsSuspenseQuery>;
export type ListCourtsQueryResult = Apollo.QueryResult<ListCourtsQuery, ListCourtsQueryVariables>;
export const CreateCourtDocument = gql`
    mutation CreateCourt($input: CreateCourtInput!) {
  createCourt(input: $input) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;
export type CreateCourtMutationFn = Apollo.MutationFunction<CreateCourtMutation, CreateCourtMutationVariables>;

/**
 * __useCreateCourtMutation__
 *
 * To run a mutation, you first call `useCreateCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourtMutation, { data, loading, error }] = useCreateCourtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCourtMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourtMutation, CreateCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourtMutation, CreateCourtMutationVariables>(CreateCourtDocument, options);
      }
export type CreateCourtMutationHookResult = ReturnType<typeof useCreateCourtMutation>;
export type CreateCourtMutationResult = Apollo.MutationResult<CreateCourtMutation>;
export type CreateCourtMutationOptions = Apollo.BaseMutationOptions<CreateCourtMutation, CreateCourtMutationVariables>;
export const UpdateCourtDocument = gql`
    mutation UpdateCourt($input: UpdateCourtInput!) {
  updateCourt(input: $input) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;
export type UpdateCourtMutationFn = Apollo.MutationFunction<UpdateCourtMutation, UpdateCourtMutationVariables>;

/**
 * __useUpdateCourtMutation__
 *
 * To run a mutation, you first call `useUpdateCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourtMutation, { data, loading, error }] = useUpdateCourtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourtMutation, UpdateCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourtMutation, UpdateCourtMutationVariables>(UpdateCourtDocument, options);
      }
export type UpdateCourtMutationHookResult = ReturnType<typeof useUpdateCourtMutation>;
export type UpdateCourtMutationResult = Apollo.MutationResult<UpdateCourtMutation>;
export type UpdateCourtMutationOptions = Apollo.BaseMutationOptions<UpdateCourtMutation, UpdateCourtMutationVariables>;
export const DeleteCourtDocument = gql`
    mutation DeleteCourt($id: ID!) {
  deleteCourt(id: $id) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;
export type DeleteCourtMutationFn = Apollo.MutationFunction<DeleteCourtMutation, DeleteCourtMutationVariables>;

/**
 * __useDeleteCourtMutation__
 *
 * To run a mutation, you first call `useDeleteCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourtMutation, { data, loading, error }] = useDeleteCourtMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourtMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourtMutation, DeleteCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourtMutation, DeleteCourtMutationVariables>(DeleteCourtDocument, options);
      }
export type DeleteCourtMutationHookResult = ReturnType<typeof useDeleteCourtMutation>;
export type DeleteCourtMutationResult = Apollo.MutationResult<DeleteCourtMutation>;
export type DeleteCourtMutationOptions = Apollo.BaseMutationOptions<DeleteCourtMutation, DeleteCourtMutationVariables>;
export const DeleteCourtsDocument = gql`
    mutation DeleteCourts($ids: [ID!]!) {
  deleteCourts(ids: $ids) {
    ...Court
  }
}
    ${CourtFragmentDoc}`;
export type DeleteCourtsMutationFn = Apollo.MutationFunction<DeleteCourtsMutation, DeleteCourtsMutationVariables>;

/**
 * __useDeleteCourtsMutation__
 *
 * To run a mutation, you first call `useDeleteCourtsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourtsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourtsMutation, { data, loading, error }] = useDeleteCourtsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCourtsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourtsMutation, DeleteCourtsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourtsMutation, DeleteCourtsMutationVariables>(DeleteCourtsDocument, options);
      }
export type DeleteCourtsMutationHookResult = ReturnType<typeof useDeleteCourtsMutation>;
export type DeleteCourtsMutationResult = Apollo.MutationResult<DeleteCourtsMutation>;
export type DeleteCourtsMutationOptions = Apollo.BaseMutationOptions<DeleteCourtsMutation, DeleteCourtsMutationVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($id: ID!, $pagination: PaginationInput, $sort: SortInput, $filter: JobFilter) {
  getCustomer(id: $id) {
    ...Customer
    jobs(pagination: $pagination, sort: $sort, filter: $filter) {
      data {
        ...Job
        finishedBy {
          ...Employee
        }
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${CustomerFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
// @ts-ignore
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery | undefined, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($ids: [ID!]!) {
  getCustomers(ids: $ids) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables> & ({ variables: GetCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
// @ts-ignore
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery | undefined, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const ListCustomersDocument = gql`
    query ListCustomers($pagination: PaginationInput, $sort: SortInput, $filter: CustomerFilter) {
  listCustomers(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Customer
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useListCustomersQuery__
 *
 * To run a query within a React component, call `useListCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListCustomersQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, options);
      }
export function useListCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, options);
        }
// @ts-ignore
export function useListCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<ListCustomersQuery, ListCustomersQueryVariables>;
export function useListCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<ListCustomersQuery | undefined, ListCustomersQueryVariables>;
export function useListCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, options);
        }
export type ListCustomersQueryHookResult = ReturnType<typeof useListCustomersQuery>;
export type ListCustomersLazyQueryHookResult = ReturnType<typeof useListCustomersLazyQuery>;
export type ListCustomersSuspenseQueryHookResult = ReturnType<typeof useListCustomersSuspenseQuery>;
export type ListCustomersQueryResult = Apollo.QueryResult<ListCustomersQuery, ListCustomersQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: ID!) {
  deleteCustomer(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DeleteCustomersDocument = gql`
    mutation DeleteCustomers($ids: [ID!]!) {
  deleteCustomers(ids: $ids) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export type DeleteCustomersMutationFn = Apollo.MutationFunction<DeleteCustomersMutation, DeleteCustomersMutationVariables>;

/**
 * __useDeleteCustomersMutation__
 *
 * To run a mutation, you first call `useDeleteCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomersMutation, { data, loading, error }] = useDeleteCustomersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCustomersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomersMutation, DeleteCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomersMutation, DeleteCustomersMutationVariables>(DeleteCustomersDocument, options);
      }
export type DeleteCustomersMutationHookResult = ReturnType<typeof useDeleteCustomersMutation>;
export type DeleteCustomersMutationResult = Apollo.MutationResult<DeleteCustomersMutation>;
export type DeleteCustomersMutationOptions = Apollo.BaseMutationOptions<DeleteCustomersMutation, DeleteCustomersMutationVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($id: ID!, $jobsPagination: PaginationInput, $jobsSort: SortInput, $jobsFilter: JobFilter, $workshiftsPagination: PaginationInput, $workshiftsSort: SortInput, $workshiftsFilter: WorkShiftFilter) {
  getEmployee(id: $id) {
    ...Employee
    user {
      ...User
    }
    jobsFinished(pagination: $jobsPagination, sort: $jobsSort, filter: $jobsFilter) {
      data {
        ...Job
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
    workShifts(
      pagination: $workshiftsPagination
      sort: $workshiftsSort
      filter: $workshiftsFilter
    ) {
      data {
        ...WorkShift
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
    messagesSent(pagination: {perPage: 50}, sort: {field: "createdAt", order: ASC}) {
      data {
        ...Message
        customer {
          ...Customer
        }
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}
${JobFragmentDoc}
${WorkShiftFragmentDoc}
${MessageFragmentDoc}
${CustomerFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jobsPagination: // value for 'jobsPagination'
 *      jobsSort: // value for 'jobsSort'
 *      jobsFilter: // value for 'jobsFilter'
 *      workshiftsPagination: // value for 'workshiftsPagination'
 *      workshiftsSort: // value for 'workshiftsSort'
 *      workshiftsFilter: // value for 'workshiftsFilter'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables> & ({ variables: GetEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
// @ts-ignore
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeQuery | undefined, GetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeSuspenseQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    ...Employee
    user {
      ...User
    }
    account {
      ...Account
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}
${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($ids: [ID!]!) {
  getEmployees(ids: $ids) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables> & ({ variables: GetEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
// @ts-ignore
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesQuery | undefined, GetEmployeesQueryVariables>;
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const ListEmployeesDocument = gql`
    query ListEmployees($pagination: PaginationInput, $sort: SortInput, $filter: EmployeeFilter) {
  listEmployees(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Employee
      user {
        ...User
      }
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;

/**
 * __useListEmployeesQuery__
 *
 * To run a query within a React component, call `useListEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
      }
export function useListEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
// @ts-ignore
export function useListEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export function useListEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<ListEmployeesQuery | undefined, ListEmployeesQueryVariables>;
export function useListEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export type ListEmployeesQueryHookResult = ReturnType<typeof useListEmployeesQuery>;
export type ListEmployeesLazyQueryHookResult = ReturnType<typeof useListEmployeesLazyQuery>;
export type ListEmployeesSuspenseQueryHookResult = ReturnType<typeof useListEmployeesSuspenseQuery>;
export type ListEmployeesQueryResult = Apollo.QueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const InviteEmployeeDocument = gql`
    mutation InviteEmployee($input: InviteEmployeeInput!) {
  inviteEmployee(input: $input) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type InviteEmployeeMutationFn = Apollo.MutationFunction<InviteEmployeeMutation, InviteEmployeeMutationVariables>;

/**
 * __useInviteEmployeeMutation__
 *
 * To run a mutation, you first call `useInviteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteEmployeeMutation, { data, loading, error }] = useInviteEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<InviteEmployeeMutation, InviteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteEmployeeMutation, InviteEmployeeMutationVariables>(InviteEmployeeDocument, options);
      }
export type InviteEmployeeMutationHookResult = ReturnType<typeof useInviteEmployeeMutation>;
export type InviteEmployeeMutationResult = Apollo.MutationResult<InviteEmployeeMutation>;
export type InviteEmployeeMutationOptions = Apollo.BaseMutationOptions<InviteEmployeeMutation, InviteEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: UpdateEmployeeInput!) {
  updateEmployee(input: $input) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($id: ID!) {
  deleteEmployee(id: $id) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const DeleteEmployeesDocument = gql`
    mutation DeleteEmployees($ids: [ID!]!) {
  deleteEmployees(ids: $ids) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type DeleteEmployeesMutationFn = Apollo.MutationFunction<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>;

/**
 * __useDeleteEmployeesMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeesMutation, { data, loading, error }] = useDeleteEmployeesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>(DeleteEmployeesDocument, options);
      }
export type DeleteEmployeesMutationHookResult = ReturnType<typeof useDeleteEmployeesMutation>;
export type DeleteEmployeesMutationResult = Apollo.MutationResult<DeleteEmployeesMutation>;
export type DeleteEmployeesMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>;
export const DeactivateEmployeeDocument = gql`
    mutation DeactivateEmployee($id: ID!) {
  deactivateEmployee(id: $id) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type DeactivateEmployeeMutationFn = Apollo.MutationFunction<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>;

/**
 * __useDeactivateEmployeeMutation__
 *
 * To run a mutation, you first call `useDeactivateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateEmployeeMutation, { data, loading, error }] = useDeactivateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>(DeactivateEmployeeDocument, options);
      }
export type DeactivateEmployeeMutationHookResult = ReturnType<typeof useDeactivateEmployeeMutation>;
export type DeactivateEmployeeMutationResult = Apollo.MutationResult<DeactivateEmployeeMutation>;
export type DeactivateEmployeeMutationOptions = Apollo.BaseMutationOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>;
export const ReactivateEmployeeDocument = gql`
    mutation ReactivateEmployee($id: ID!) {
  reactivateEmployee(id: $id) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type ReactivateEmployeeMutationFn = Apollo.MutationFunction<ReactivateEmployeeMutation, ReactivateEmployeeMutationVariables>;

/**
 * __useReactivateEmployeeMutation__
 *
 * To run a mutation, you first call `useReactivateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateEmployeeMutation, { data, loading, error }] = useReactivateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateEmployeeMutation, ReactivateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateEmployeeMutation, ReactivateEmployeeMutationVariables>(ReactivateEmployeeDocument, options);
      }
export type ReactivateEmployeeMutationHookResult = ReturnType<typeof useReactivateEmployeeMutation>;
export type ReactivateEmployeeMutationResult = Apollo.MutationResult<ReactivateEmployeeMutation>;
export type ReactivateEmployeeMutationOptions = Apollo.BaseMutationOptions<ReactivateEmployeeMutation, ReactivateEmployeeMutationVariables>;
export const ResetEmployeePasswordDocument = gql`
    mutation ResetEmployeePassword($id: ID!, $newPassword: Password!) {
  resetEmployeePassword(id: $id, newPassword: $newPassword) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type ResetEmployeePasswordMutationFn = Apollo.MutationFunction<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>;

/**
 * __useResetEmployeePasswordMutation__
 *
 * To run a mutation, you first call `useResetEmployeePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEmployeePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEmployeePasswordMutation, { data, loading, error }] = useResetEmployeePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetEmployeePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>(ResetEmployeePasswordDocument, options);
      }
export type ResetEmployeePasswordMutationHookResult = ReturnType<typeof useResetEmployeePasswordMutation>;
export type ResetEmployeePasswordMutationResult = Apollo.MutationResult<ResetEmployeePasswordMutation>;
export type ResetEmployeePasswordMutationOptions = Apollo.BaseMutationOptions<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($id: ID!) {
  resendInvitation(id: $id) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const UpdateEmployeeSettingsDocument = gql`
    mutation UpdateEmployeeSettings($input: UpdateEmployeeSettingsInput!) {
  updateEmployeeSettings(input: $input) {
    ...Employee
    user {
      ...User
    }
  }
}
    ${EmployeeFragmentDoc}
${UserFragmentDoc}`;
export type UpdateEmployeeSettingsMutationFn = Apollo.MutationFunction<UpdateEmployeeSettingsMutation, UpdateEmployeeSettingsMutationVariables>;

/**
 * __useUpdateEmployeeSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeSettingsMutation, { data, loading, error }] = useUpdateEmployeeSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeSettingsMutation, UpdateEmployeeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeSettingsMutation, UpdateEmployeeSettingsMutationVariables>(UpdateEmployeeSettingsDocument, options);
      }
export type UpdateEmployeeSettingsMutationHookResult = ReturnType<typeof useUpdateEmployeeSettingsMutation>;
export type UpdateEmployeeSettingsMutationResult = Apollo.MutationResult<UpdateEmployeeSettingsMutation>;
export type UpdateEmployeeSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeSettingsMutation, UpdateEmployeeSettingsMutationVariables>;
export const GetJobDocument = gql`
    query GetJob($id: ID!) {
  getJob(id: $id) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> & ({ variables: GetJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
// @ts-ignore
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobQuery, GetJobQueryVariables>;
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobQuery | undefined, GetJobQueryVariables>;
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const UpdateJobStatusDocument = gql`
    mutation UpdateJobStatus($input: UpdateJobStatusInput!) {
  updateJobStatus(input: $input) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type UpdateJobStatusMutationFn = Apollo.MutationFunction<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>;

/**
 * __useUpdateJobStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobStatusMutation, { data, loading, error }] = useUpdateJobStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>(UpdateJobStatusDocument, options);
      }
export type UpdateJobStatusMutationHookResult = ReturnType<typeof useUpdateJobStatusMutation>;
export type UpdateJobStatusMutationResult = Apollo.MutationResult<UpdateJobStatusMutation>;
export type UpdateJobStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>;
export const UpdateJobsStatusDocument = gql`
    mutation UpdateJobsStatus($input: UpdateJobsStatusInput!) {
  updateJobsStatus(input: $input) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type UpdateJobsStatusMutationFn = Apollo.MutationFunction<UpdateJobsStatusMutation, UpdateJobsStatusMutationVariables>;

/**
 * __useUpdateJobsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsStatusMutation, { data, loading, error }] = useUpdateJobsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobsStatusMutation, UpdateJobsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobsStatusMutation, UpdateJobsStatusMutationVariables>(UpdateJobsStatusDocument, options);
      }
export type UpdateJobsStatusMutationHookResult = ReturnType<typeof useUpdateJobsStatusMutation>;
export type UpdateJobsStatusMutationResult = Apollo.MutationResult<UpdateJobsStatusMutation>;
export type UpdateJobsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobsStatusMutation, UpdateJobsStatusMutationVariables>;
export const GetJobsDocument = gql`
    query GetJobs($ids: [ID!]!) {
  getJobs(ids: $ids) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables> & ({ variables: GetJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
// @ts-ignore
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobsQuery, GetJobsQueryVariables>;
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobsQuery | undefined, GetJobsQueryVariables>;
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const ListJobsDocument = gql`
    query ListJobs($pagination: PaginationInput, $sort: SortInput, $filter: JobFilter) {
  listJobs(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...JobWithRelations
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;

/**
 * __useListJobsQuery__
 *
 * To run a query within a React component, call `useListJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListJobsQuery(baseOptions?: Apollo.QueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
      }
export function useListJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
        }
// @ts-ignore
export function useListJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobsQuery, ListJobsQueryVariables>;
export function useListJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobsQuery | undefined, ListJobsQueryVariables>;
export function useListJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
        }
export type ListJobsQueryHookResult = ReturnType<typeof useListJobsQuery>;
export type ListJobsLazyQueryHookResult = ReturnType<typeof useListJobsLazyQuery>;
export type ListJobsSuspenseQueryHookResult = ReturnType<typeof useListJobsSuspenseQuery>;
export type ListJobsQueryResult = Apollo.QueryResult<ListJobsQuery, ListJobsQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($input: CreateJobInput!) {
  createJob(input: $input) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($input: UpdateJobInput!) {
  updateJob(input: $input) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($id: ID!) {
  deleteJob(id: $id) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const DeleteJobsDocument = gql`
    mutation DeleteJobs($ids: [ID!]!) {
  deleteJobs(ids: $ids) {
    ...JobWithRelations
  }
}
    ${JobWithRelationsFragmentDoc}
${JobFragmentDoc}
${EmployeeFragmentDoc}
${CustomerFragmentDoc}`;
export type DeleteJobsMutationFn = Apollo.MutationFunction<DeleteJobsMutation, DeleteJobsMutationVariables>;

/**
 * __useDeleteJobsMutation__
 *
 * To run a mutation, you first call `useDeleteJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobsMutation, { data, loading, error }] = useDeleteJobsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteJobsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobsMutation, DeleteJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobsMutation, DeleteJobsMutationVariables>(DeleteJobsDocument, options);
      }
export type DeleteJobsMutationHookResult = ReturnType<typeof useDeleteJobsMutation>;
export type DeleteJobsMutationResult = Apollo.MutationResult<DeleteJobsMutation>;
export type DeleteJobsMutationOptions = Apollo.BaseMutationOptions<DeleteJobsMutation, DeleteJobsMutationVariables>;
export const GetMessageDocument = gql`
    query GetMessage($id: ID!) {
  getMessage(id: $id) {
    ...MessageWithRelations
  }
}
    ${MessageWithRelationsFragmentDoc}
${MessageFragmentDoc}
${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}
${CustomerFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions: Apollo.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables> & ({ variables: GetMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
      }
export function useGetMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
        }
// @ts-ignore
export function useGetMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageQuery, GetMessageQueryVariables>;
export function useGetMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageQuery | undefined, GetMessageQueryVariables>;
export function useGetMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
        }
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageSuspenseQueryHookResult = ReturnType<typeof useGetMessageSuspenseQuery>;
export type GetMessageQueryResult = Apollo.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const GetMessagesDocument = gql`
    query GetMessages($ids: [ID!]!) {
  getMessages(ids: $ids) {
    ...MessageWithRelations
  }
}
    ${MessageWithRelationsFragmentDoc}
${MessageFragmentDoc}
${AccountFragmentDoc}
${BillingInfoFragmentDoc}
${SubscriptionFragmentDoc}
${SubscriptionPlanFragmentDoc}
${SubscriptionPriceFragmentDoc}
${CustomerFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables> & ({ variables: GetMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
      }
export function useGetMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
// @ts-ignore
export function useGetMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export function useGetMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesQuery | undefined, GetMessagesQueryVariables>;
export function useGetMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSuspenseQuery>;
export type GetMessagesQueryResult = Apollo.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const ListMessagesDocument = gql`
    query ListMessages($pagination: PaginationInput, $sort: SortInput, $filter: MessageFilter) {
  listMessages(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Message
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MessageFragmentDoc}`;

/**
 * __useListMessagesQuery__
 *
 * To run a query within a React component, call `useListMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessagesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListMessagesQuery(baseOptions?: Apollo.QueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
      }
export function useListMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
        }
// @ts-ignore
export function useListMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<ListMessagesQuery, ListMessagesQueryVariables>;
export function useListMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<ListMessagesQuery | undefined, ListMessagesQueryVariables>;
export function useListMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMessagesQuery, ListMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMessagesQuery, ListMessagesQueryVariables>(ListMessagesDocument, options);
        }
export type ListMessagesQueryHookResult = ReturnType<typeof useListMessagesQuery>;
export type ListMessagesLazyQueryHookResult = ReturnType<typeof useListMessagesLazyQuery>;
export type ListMessagesSuspenseQueryHookResult = ReturnType<typeof useListMessagesSuspenseQuery>;
export type ListMessagesQueryResult = Apollo.QueryResult<ListMessagesQuery, ListMessagesQueryVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const GetPingDocument = gql`
    query GetPing {
  ping
}
    `;

/**
 * __useGetPingQuery__
 *
 * To run a query within a React component, call `useGetPingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPingQuery(baseOptions?: Apollo.QueryHookOptions<GetPingQuery, GetPingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPingQuery, GetPingQueryVariables>(GetPingDocument, options);
      }
export function useGetPingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPingQuery, GetPingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPingQuery, GetPingQueryVariables>(GetPingDocument, options);
        }
// @ts-ignore
export function useGetPingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPingQuery, GetPingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPingQuery, GetPingQueryVariables>;
export function useGetPingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPingQuery, GetPingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPingQuery | undefined, GetPingQueryVariables>;
export function useGetPingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPingQuery, GetPingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPingQuery, GetPingQueryVariables>(GetPingDocument, options);
        }
export type GetPingQueryHookResult = ReturnType<typeof useGetPingQuery>;
export type GetPingLazyQueryHookResult = ReturnType<typeof useGetPingLazyQuery>;
export type GetPingSuspenseQueryHookResult = ReturnType<typeof useGetPingSuspenseQuery>;
export type GetPingQueryResult = Apollo.QueryResult<GetPingQuery, GetPingQueryVariables>;
export const GetPongDocument = gql`
    mutation GetPong {
  pong
}
    `;
export type GetPongMutationFn = Apollo.MutationFunction<GetPongMutation, GetPongMutationVariables>;

/**
 * __useGetPongMutation__
 *
 * To run a mutation, you first call `useGetPongMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPongMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPongMutation, { data, loading, error }] = useGetPongMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetPongMutation(baseOptions?: Apollo.MutationHookOptions<GetPongMutation, GetPongMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPongMutation, GetPongMutationVariables>(GetPongDocument, options);
      }
export type GetPongMutationHookResult = ReturnType<typeof useGetPongMutation>;
export type GetPongMutationResult = Apollo.MutationResult<GetPongMutation>;
export type GetPongMutationOptions = Apollo.BaseMutationOptions<GetPongMutation, GetPongMutationVariables>;
export const PayrollReportDocument = gql`
    query PayrollReport($start: DateTime, $end: DateTime) {
  listEmployees {
    data {
      ...Employee
      jobsFinished(
        filter: {finishedAt: {gt: $start, lt: $end}}
        pagination: {perPage: 1000}
      ) {
        data {
          ...Job
          customer {
            ...Customer
          }
        }
      }
      workShifts(
        filter: {end: {gt: $start, lt: $end}, status: WORKED}
        pagination: {perPage: 1000}
      ) {
        data {
          ...WorkShift
        }
      }
    }
  }
}
    ${EmployeeFragmentDoc}
${JobFragmentDoc}
${CustomerFragmentDoc}
${WorkShiftFragmentDoc}`;

/**
 * __usePayrollReportQuery__
 *
 * To run a query within a React component, call `usePayrollReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollReportQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function usePayrollReportQuery(baseOptions?: Apollo.QueryHookOptions<PayrollReportQuery, PayrollReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollReportQuery, PayrollReportQueryVariables>(PayrollReportDocument, options);
      }
export function usePayrollReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollReportQuery, PayrollReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollReportQuery, PayrollReportQueryVariables>(PayrollReportDocument, options);
        }
// @ts-ignore
export function usePayrollReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayrollReportQuery, PayrollReportQueryVariables>): Apollo.UseSuspenseQueryResult<PayrollReportQuery, PayrollReportQueryVariables>;
export function usePayrollReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollReportQuery, PayrollReportQueryVariables>): Apollo.UseSuspenseQueryResult<PayrollReportQuery | undefined, PayrollReportQueryVariables>;
export function usePayrollReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollReportQuery, PayrollReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollReportQuery, PayrollReportQueryVariables>(PayrollReportDocument, options);
        }
export type PayrollReportQueryHookResult = ReturnType<typeof usePayrollReportQuery>;
export type PayrollReportLazyQueryHookResult = ReturnType<typeof usePayrollReportLazyQuery>;
export type PayrollReportSuspenseQueryHookResult = ReturnType<typeof usePayrollReportSuspenseQuery>;
export type PayrollReportQueryResult = Apollo.QueryResult<PayrollReportQuery, PayrollReportQueryVariables>;
export const ListReservationsDocument = gql`
    query ListReservations($pagination: PaginationInput, $sort: SortInput, $filter: ReservationFilter) {
  listReservations(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...Reservation
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ReservationFragmentDoc}`;

/**
 * __useListReservationsQuery__
 *
 * To run a query within a React component, call `useListReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReservationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListReservationsQuery(baseOptions?: Apollo.QueryHookOptions<ListReservationsQuery, ListReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReservationsQuery, ListReservationsQueryVariables>(ListReservationsDocument, options);
      }
export function useListReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReservationsQuery, ListReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReservationsQuery, ListReservationsQueryVariables>(ListReservationsDocument, options);
        }
// @ts-ignore
export function useListReservationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListReservationsQuery, ListReservationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReservationsQuery, ListReservationsQueryVariables>;
export function useListReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReservationsQuery, ListReservationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReservationsQuery | undefined, ListReservationsQueryVariables>;
export function useListReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReservationsQuery, ListReservationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReservationsQuery, ListReservationsQueryVariables>(ListReservationsDocument, options);
        }
export type ListReservationsQueryHookResult = ReturnType<typeof useListReservationsQuery>;
export type ListReservationsLazyQueryHookResult = ReturnType<typeof useListReservationsLazyQuery>;
export type ListReservationsSuspenseQueryHookResult = ReturnType<typeof useListReservationsSuspenseQuery>;
export type ListReservationsQueryResult = Apollo.QueryResult<ListReservationsQuery, ListReservationsQueryVariables>;
export const GetReservationDocument = gql`
    query GetReservation($id: ID!) {
  getReservation(id: $id) {
    ...Reservation
  }
}
    ${ReservationFragmentDoc}`;

/**
 * __useGetReservationQuery__
 *
 * To run a query within a React component, call `useGetReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReservationQuery(baseOptions: Apollo.QueryHookOptions<GetReservationQuery, GetReservationQueryVariables> & ({ variables: GetReservationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationQuery, GetReservationQueryVariables>(GetReservationDocument, options);
      }
export function useGetReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationQuery, GetReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationQuery, GetReservationQueryVariables>(GetReservationDocument, options);
        }
// @ts-ignore
export function useGetReservationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReservationQuery, GetReservationQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationQuery, GetReservationQueryVariables>;
export function useGetReservationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationQuery, GetReservationQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationQuery | undefined, GetReservationQueryVariables>;
export function useGetReservationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationQuery, GetReservationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationQuery, GetReservationQueryVariables>(GetReservationDocument, options);
        }
export type GetReservationQueryHookResult = ReturnType<typeof useGetReservationQuery>;
export type GetReservationLazyQueryHookResult = ReturnType<typeof useGetReservationLazyQuery>;
export type GetReservationSuspenseQueryHookResult = ReturnType<typeof useGetReservationSuspenseQuery>;
export type GetReservationQueryResult = Apollo.QueryResult<GetReservationQuery, GetReservationQueryVariables>;
export const ListReservationSeriesDocument = gql`
    query ListReservationSeries($pagination: PaginationInput, $sort: SortInput, $filter: ReservationSeriesFilter) {
  listReservationSeries(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...ReservationSeries
      reservations {
        data {
          ...Reservation
        }
        total
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
      }
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ReservationSeriesFragmentDoc}
${ReservationFragmentDoc}`;

/**
 * __useListReservationSeriesQuery__
 *
 * To run a query within a React component, call `useListReservationSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReservationSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReservationSeriesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListReservationSeriesQuery(baseOptions?: Apollo.QueryHookOptions<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>(ListReservationSeriesDocument, options);
      }
export function useListReservationSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>(ListReservationSeriesDocument, options);
        }
// @ts-ignore
export function useListReservationSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>;
export function useListReservationSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<ListReservationSeriesQuery | undefined, ListReservationSeriesQueryVariables>;
export function useListReservationSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>(ListReservationSeriesDocument, options);
        }
export type ListReservationSeriesQueryHookResult = ReturnType<typeof useListReservationSeriesQuery>;
export type ListReservationSeriesLazyQueryHookResult = ReturnType<typeof useListReservationSeriesLazyQuery>;
export type ListReservationSeriesSuspenseQueryHookResult = ReturnType<typeof useListReservationSeriesSuspenseQuery>;
export type ListReservationSeriesQueryResult = Apollo.QueryResult<ListReservationSeriesQuery, ListReservationSeriesQueryVariables>;
export const GetReservationSeriesDocument = gql`
    query GetReservationSeries($id: ID!) {
  getReservationSeries(id: $id) {
    ...ReservationSeries
    reservations {
      data {
        ...Reservation
      }
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ReservationSeriesFragmentDoc}
${ReservationFragmentDoc}`;

/**
 * __useGetReservationSeriesQuery__
 *
 * To run a query within a React component, call `useGetReservationSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReservationSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetReservationSeriesQuery, GetReservationSeriesQueryVariables> & ({ variables: GetReservationSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>(GetReservationSeriesDocument, options);
      }
export function useGetReservationSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>(GetReservationSeriesDocument, options);
        }
// @ts-ignore
export function useGetReservationSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>;
export function useGetReservationSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationSeriesQuery | undefined, GetReservationSeriesQueryVariables>;
export function useGetReservationSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>(GetReservationSeriesDocument, options);
        }
export type GetReservationSeriesQueryHookResult = ReturnType<typeof useGetReservationSeriesQuery>;
export type GetReservationSeriesLazyQueryHookResult = ReturnType<typeof useGetReservationSeriesLazyQuery>;
export type GetReservationSeriesSuspenseQueryHookResult = ReturnType<typeof useGetReservationSeriesSuspenseQuery>;
export type GetReservationSeriesQueryResult = Apollo.QueryResult<GetReservationSeriesQuery, GetReservationSeriesQueryVariables>;
export const GetReservationSeriesListDocument = gql`
    query GetReservationSeriesList($ids: [ID!]!) {
  getReservationSeriesList(ids: $ids) {
    ...ReservationSeries
  }
}
    ${ReservationSeriesFragmentDoc}`;

/**
 * __useGetReservationSeriesListQuery__
 *
 * To run a query within a React component, call `useGetReservationSeriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationSeriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationSeriesListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetReservationSeriesListQuery(baseOptions: Apollo.QueryHookOptions<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables> & ({ variables: GetReservationSeriesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>(GetReservationSeriesListDocument, options);
      }
export function useGetReservationSeriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>(GetReservationSeriesListDocument, options);
        }
// @ts-ignore
export function useGetReservationSeriesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>;
export function useGetReservationSeriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationSeriesListQuery | undefined, GetReservationSeriesListQueryVariables>;
export function useGetReservationSeriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>(GetReservationSeriesListDocument, options);
        }
export type GetReservationSeriesListQueryHookResult = ReturnType<typeof useGetReservationSeriesListQuery>;
export type GetReservationSeriesListLazyQueryHookResult = ReturnType<typeof useGetReservationSeriesListLazyQuery>;
export type GetReservationSeriesListSuspenseQueryHookResult = ReturnType<typeof useGetReservationSeriesListSuspenseQuery>;
export type GetReservationSeriesListQueryResult = Apollo.QueryResult<GetReservationSeriesListQuery, GetReservationSeriesListQueryVariables>;
export const CreateReservationDocument = gql`
    mutation CreateReservation($input: CreateReservationInput!) {
  createReservation(input: $input) {
    ...Reservation
  }
}
    ${ReservationFragmentDoc}`;
export type CreateReservationMutationFn = Apollo.MutationFunction<CreateReservationMutation, CreateReservationMutationVariables>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationMutation, CreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationMutation, CreateReservationMutationVariables>(CreateReservationDocument, options);
      }
export type CreateReservationMutationHookResult = ReturnType<typeof useCreateReservationMutation>;
export type CreateReservationMutationResult = Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables>;
export const UpdateReservationDocument = gql`
    mutation UpdateReservation($input: UpdateReservationInput!) {
  updateReservation(input: $input) {
    ...Reservation
  }
}
    ${ReservationFragmentDoc}`;
export type UpdateReservationMutationFn = Apollo.MutationFunction<UpdateReservationMutation, UpdateReservationMutationVariables>;

/**
 * __useUpdateReservationMutation__
 *
 * To run a mutation, you first call `useUpdateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationMutation, { data, loading, error }] = useUpdateReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationMutation, UpdateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationMutation, UpdateReservationMutationVariables>(UpdateReservationDocument, options);
      }
export type UpdateReservationMutationHookResult = ReturnType<typeof useUpdateReservationMutation>;
export type UpdateReservationMutationResult = Apollo.MutationResult<UpdateReservationMutation>;
export type UpdateReservationMutationOptions = Apollo.BaseMutationOptions<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const DeleteReservationDocument = gql`
    mutation DeleteReservation($id: ID!) {
  deleteReservation(id: $id) {
    id
  }
}
    `;
export type DeleteReservationMutationFn = Apollo.MutationFunction<DeleteReservationMutation, DeleteReservationMutationVariables>;

/**
 * __useDeleteReservationMutation__
 *
 * To run a mutation, you first call `useDeleteReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservationMutation, { data, loading, error }] = useDeleteReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReservationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservationMutation, DeleteReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservationMutation, DeleteReservationMutationVariables>(DeleteReservationDocument, options);
      }
export type DeleteReservationMutationHookResult = ReturnType<typeof useDeleteReservationMutation>;
export type DeleteReservationMutationResult = Apollo.MutationResult<DeleteReservationMutation>;
export type DeleteReservationMutationOptions = Apollo.BaseMutationOptions<DeleteReservationMutation, DeleteReservationMutationVariables>;
export const CreateReservationSeriesDocument = gql`
    mutation CreateReservationSeries($input: CreateReservationSeriesInput!) {
  createReservationSeries(input: $input) {
    ...ReservationSeries
  }
}
    ${ReservationSeriesFragmentDoc}`;
export type CreateReservationSeriesMutationFn = Apollo.MutationFunction<CreateReservationSeriesMutation, CreateReservationSeriesMutationVariables>;

/**
 * __useCreateReservationSeriesMutation__
 *
 * To run a mutation, you first call `useCreateReservationSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationSeriesMutation, { data, loading, error }] = useCreateReservationSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationSeriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationSeriesMutation, CreateReservationSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationSeriesMutation, CreateReservationSeriesMutationVariables>(CreateReservationSeriesDocument, options);
      }
export type CreateReservationSeriesMutationHookResult = ReturnType<typeof useCreateReservationSeriesMutation>;
export type CreateReservationSeriesMutationResult = Apollo.MutationResult<CreateReservationSeriesMutation>;
export type CreateReservationSeriesMutationOptions = Apollo.BaseMutationOptions<CreateReservationSeriesMutation, CreateReservationSeriesMutationVariables>;
export const UpdateReservationSeriesDocument = gql`
    mutation UpdateReservationSeries($input: UpdateReservationSeriesInput!) {
  updateReservationSeries(input: $input) {
    ...ReservationSeries
  }
}
    ${ReservationSeriesFragmentDoc}`;
export type UpdateReservationSeriesMutationFn = Apollo.MutationFunction<UpdateReservationSeriesMutation, UpdateReservationSeriesMutationVariables>;

/**
 * __useUpdateReservationSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateReservationSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationSeriesMutation, { data, loading, error }] = useUpdateReservationSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReservationSeriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationSeriesMutation, UpdateReservationSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationSeriesMutation, UpdateReservationSeriesMutationVariables>(UpdateReservationSeriesDocument, options);
      }
export type UpdateReservationSeriesMutationHookResult = ReturnType<typeof useUpdateReservationSeriesMutation>;
export type UpdateReservationSeriesMutationResult = Apollo.MutationResult<UpdateReservationSeriesMutation>;
export type UpdateReservationSeriesMutationOptions = Apollo.BaseMutationOptions<UpdateReservationSeriesMutation, UpdateReservationSeriesMutationVariables>;
export const DeleteReservationSeriesDocument = gql`
    mutation DeleteReservationSeries($id: ID!) {
  deleteReservationSeries(id: $id) {
    id
  }
}
    `;
export type DeleteReservationSeriesMutationFn = Apollo.MutationFunction<DeleteReservationSeriesMutation, DeleteReservationSeriesMutationVariables>;

/**
 * __useDeleteReservationSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteReservationSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservationSeriesMutation, { data, loading, error }] = useDeleteReservationSeriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReservationSeriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservationSeriesMutation, DeleteReservationSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservationSeriesMutation, DeleteReservationSeriesMutationVariables>(DeleteReservationSeriesDocument, options);
      }
export type DeleteReservationSeriesMutationHookResult = ReturnType<typeof useDeleteReservationSeriesMutation>;
export type DeleteReservationSeriesMutationResult = Apollo.MutationResult<DeleteReservationSeriesMutation>;
export type DeleteReservationSeriesMutationOptions = Apollo.BaseMutationOptions<DeleteReservationSeriesMutation, DeleteReservationSeriesMutationVariables>;
export const DeleteReservationSeriesListDocument = gql`
    mutation DeleteReservationSeriesList($ids: [ID!]!) {
  deleteReservationSeriesList(ids: $ids) {
    id
  }
}
    `;
export type DeleteReservationSeriesListMutationFn = Apollo.MutationFunction<DeleteReservationSeriesListMutation, DeleteReservationSeriesListMutationVariables>;

/**
 * __useDeleteReservationSeriesListMutation__
 *
 * To run a mutation, you first call `useDeleteReservationSeriesListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationSeriesListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservationSeriesListMutation, { data, loading, error }] = useDeleteReservationSeriesListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteReservationSeriesListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservationSeriesListMutation, DeleteReservationSeriesListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservationSeriesListMutation, DeleteReservationSeriesListMutationVariables>(DeleteReservationSeriesListDocument, options);
      }
export type DeleteReservationSeriesListMutationHookResult = ReturnType<typeof useDeleteReservationSeriesListMutation>;
export type DeleteReservationSeriesListMutationResult = Apollo.MutationResult<DeleteReservationSeriesListMutation>;
export type DeleteReservationSeriesListMutationOptions = Apollo.BaseMutationOptions<DeleteReservationSeriesListMutation, DeleteReservationSeriesListMutationVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($input: ChangeUserPasswordInput!) {
  changeUserPassword(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const UpdateUserNotificationPreferencesDocument = gql`
    mutation UpdateUserNotificationPreferences($input: UpdateUserNotificationPreferencesInput!) {
  updateUserNotificationPreferences(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateUserNotificationPreferencesMutation, UpdateUserNotificationPreferencesMutationVariables>;

/**
 * __useUpdateUserNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationPreferencesMutation, { data, loading, error }] = useUpdateUserNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationPreferencesMutation, UpdateUserNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationPreferencesMutation, UpdateUserNotificationPreferencesMutationVariables>(UpdateUserNotificationPreferencesDocument, options);
      }
export type UpdateUserNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateUserNotificationPreferencesMutation>;
export type UpdateUserNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateUserNotificationPreferencesMutation>;
export type UpdateUserNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationPreferencesMutation, UpdateUserNotificationPreferencesMutationVariables>;
export const GetWorkShiftDocument = gql`
    query GetWorkShift($id: ID!) {
  getWorkShift(id: $id) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetWorkShiftQuery__
 *
 * To run a query within a React component, call `useGetWorkShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkShiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkShiftQuery(baseOptions: Apollo.QueryHookOptions<GetWorkShiftQuery, GetWorkShiftQueryVariables> & ({ variables: GetWorkShiftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkShiftQuery, GetWorkShiftQueryVariables>(GetWorkShiftDocument, options);
      }
export function useGetWorkShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkShiftQuery, GetWorkShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkShiftQuery, GetWorkShiftQueryVariables>(GetWorkShiftDocument, options);
        }
// @ts-ignore
export function useGetWorkShiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkShiftQuery, GetWorkShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkShiftQuery, GetWorkShiftQueryVariables>;
export function useGetWorkShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkShiftQuery, GetWorkShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkShiftQuery | undefined, GetWorkShiftQueryVariables>;
export function useGetWorkShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkShiftQuery, GetWorkShiftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkShiftQuery, GetWorkShiftQueryVariables>(GetWorkShiftDocument, options);
        }
export type GetWorkShiftQueryHookResult = ReturnType<typeof useGetWorkShiftQuery>;
export type GetWorkShiftLazyQueryHookResult = ReturnType<typeof useGetWorkShiftLazyQuery>;
export type GetWorkShiftSuspenseQueryHookResult = ReturnType<typeof useGetWorkShiftSuspenseQuery>;
export type GetWorkShiftQueryResult = Apollo.QueryResult<GetWorkShiftQuery, GetWorkShiftQueryVariables>;
export const GetActiveWorkShiftDocument = gql`
    query GetActiveWorkShift($employeeId: ID) {
  getActiveWorkShift(employeeId: $employeeId) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetActiveWorkShiftQuery__
 *
 * To run a query within a React component, call `useGetActiveWorkShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveWorkShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveWorkShiftQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetActiveWorkShiftQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>(GetActiveWorkShiftDocument, options);
      }
export function useGetActiveWorkShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>(GetActiveWorkShiftDocument, options);
        }
// @ts-ignore
export function useGetActiveWorkShiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>;
export function useGetActiveWorkShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveWorkShiftQuery | undefined, GetActiveWorkShiftQueryVariables>;
export function useGetActiveWorkShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>(GetActiveWorkShiftDocument, options);
        }
export type GetActiveWorkShiftQueryHookResult = ReturnType<typeof useGetActiveWorkShiftQuery>;
export type GetActiveWorkShiftLazyQueryHookResult = ReturnType<typeof useGetActiveWorkShiftLazyQuery>;
export type GetActiveWorkShiftSuspenseQueryHookResult = ReturnType<typeof useGetActiveWorkShiftSuspenseQuery>;
export type GetActiveWorkShiftQueryResult = Apollo.QueryResult<GetActiveWorkShiftQuery, GetActiveWorkShiftQueryVariables>;
export const GetWorkShiftsDocument = gql`
    query GetWorkShifts($ids: [ID!]!) {
  getWorkShifts(ids: $ids) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useGetWorkShiftsQuery__
 *
 * To run a query within a React component, call `useGetWorkShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkShiftsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetWorkShiftsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkShiftsQuery, GetWorkShiftsQueryVariables> & ({ variables: GetWorkShiftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>(GetWorkShiftsDocument, options);
      }
export function useGetWorkShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>(GetWorkShiftsDocument, options);
        }
// @ts-ignore
export function useGetWorkShiftsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>;
export function useGetWorkShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkShiftsQuery | undefined, GetWorkShiftsQueryVariables>;
export function useGetWorkShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>(GetWorkShiftsDocument, options);
        }
export type GetWorkShiftsQueryHookResult = ReturnType<typeof useGetWorkShiftsQuery>;
export type GetWorkShiftsLazyQueryHookResult = ReturnType<typeof useGetWorkShiftsLazyQuery>;
export type GetWorkShiftsSuspenseQueryHookResult = ReturnType<typeof useGetWorkShiftsSuspenseQuery>;
export type GetWorkShiftsQueryResult = Apollo.QueryResult<GetWorkShiftsQuery, GetWorkShiftsQueryVariables>;
export const ListWorkShiftsDocument = gql`
    query ListWorkShifts($pagination: PaginationInput, $sort: SortInput, $filter: WorkShiftFilter) {
  listWorkShifts(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      ...WorkShift
    }
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useListWorkShiftsQuery__
 *
 * To run a query within a React component, call `useListWorkShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkShiftsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListWorkShiftsQuery(baseOptions?: Apollo.QueryHookOptions<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>(ListWorkShiftsDocument, options);
      }
export function useListWorkShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>(ListWorkShiftsDocument, options);
        }
// @ts-ignore
export function useListWorkShiftsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>;
export function useListWorkShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkShiftsQuery | undefined, ListWorkShiftsQueryVariables>;
export function useListWorkShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>(ListWorkShiftsDocument, options);
        }
export type ListWorkShiftsQueryHookResult = ReturnType<typeof useListWorkShiftsQuery>;
export type ListWorkShiftsLazyQueryHookResult = ReturnType<typeof useListWorkShiftsLazyQuery>;
export type ListWorkShiftsSuspenseQueryHookResult = ReturnType<typeof useListWorkShiftsSuspenseQuery>;
export type ListWorkShiftsQueryResult = Apollo.QueryResult<ListWorkShiftsQuery, ListWorkShiftsQueryVariables>;
export const CreateWorkShiftDocument = gql`
    mutation CreateWorkShift($input: CreateWorkShiftInput!) {
  createWorkShift(input: $input) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type CreateWorkShiftMutationFn = Apollo.MutationFunction<CreateWorkShiftMutation, CreateWorkShiftMutationVariables>;

/**
 * __useCreateWorkShiftMutation__
 *
 * To run a mutation, you first call `useCreateWorkShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkShiftMutation, { data, loading, error }] = useCreateWorkShiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkShiftMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkShiftMutation, CreateWorkShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkShiftMutation, CreateWorkShiftMutationVariables>(CreateWorkShiftDocument, options);
      }
export type CreateWorkShiftMutationHookResult = ReturnType<typeof useCreateWorkShiftMutation>;
export type CreateWorkShiftMutationResult = Apollo.MutationResult<CreateWorkShiftMutation>;
export type CreateWorkShiftMutationOptions = Apollo.BaseMutationOptions<CreateWorkShiftMutation, CreateWorkShiftMutationVariables>;
export const UpdateWorkShiftDocument = gql`
    mutation UpdateWorkShift($input: UpdateWorkShiftInput!) {
  updateWorkShift(input: $input) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type UpdateWorkShiftMutationFn = Apollo.MutationFunction<UpdateWorkShiftMutation, UpdateWorkShiftMutationVariables>;

/**
 * __useUpdateWorkShiftMutation__
 *
 * To run a mutation, you first call `useUpdateWorkShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkShiftMutation, { data, loading, error }] = useUpdateWorkShiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkShiftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkShiftMutation, UpdateWorkShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkShiftMutation, UpdateWorkShiftMutationVariables>(UpdateWorkShiftDocument, options);
      }
export type UpdateWorkShiftMutationHookResult = ReturnType<typeof useUpdateWorkShiftMutation>;
export type UpdateWorkShiftMutationResult = Apollo.MutationResult<UpdateWorkShiftMutation>;
export type UpdateWorkShiftMutationOptions = Apollo.BaseMutationOptions<UpdateWorkShiftMutation, UpdateWorkShiftMutationVariables>;
export const DeleteWorkShiftDocument = gql`
    mutation DeleteWorkShift($id: ID!) {
  deleteWorkShift(id: $id) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type DeleteWorkShiftMutationFn = Apollo.MutationFunction<DeleteWorkShiftMutation, DeleteWorkShiftMutationVariables>;

/**
 * __useDeleteWorkShiftMutation__
 *
 * To run a mutation, you first call `useDeleteWorkShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkShiftMutation, { data, loading, error }] = useDeleteWorkShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkShiftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkShiftMutation, DeleteWorkShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkShiftMutation, DeleteWorkShiftMutationVariables>(DeleteWorkShiftDocument, options);
      }
export type DeleteWorkShiftMutationHookResult = ReturnType<typeof useDeleteWorkShiftMutation>;
export type DeleteWorkShiftMutationResult = Apollo.MutationResult<DeleteWorkShiftMutation>;
export type DeleteWorkShiftMutationOptions = Apollo.BaseMutationOptions<DeleteWorkShiftMutation, DeleteWorkShiftMutationVariables>;
export const DeleteWorkShiftsDocument = gql`
    mutation DeleteWorkShifts($ids: [ID!]!) {
  deleteWorkShifts(ids: $ids) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type DeleteWorkShiftsMutationFn = Apollo.MutationFunction<DeleteWorkShiftsMutation, DeleteWorkShiftsMutationVariables>;

/**
 * __useDeleteWorkShiftsMutation__
 *
 * To run a mutation, you first call `useDeleteWorkShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkShiftsMutation, { data, loading, error }] = useDeleteWorkShiftsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteWorkShiftsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkShiftsMutation, DeleteWorkShiftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkShiftsMutation, DeleteWorkShiftsMutationVariables>(DeleteWorkShiftsDocument, options);
      }
export type DeleteWorkShiftsMutationHookResult = ReturnType<typeof useDeleteWorkShiftsMutation>;
export type DeleteWorkShiftsMutationResult = Apollo.MutationResult<DeleteWorkShiftsMutation>;
export type DeleteWorkShiftsMutationOptions = Apollo.BaseMutationOptions<DeleteWorkShiftsMutation, DeleteWorkShiftsMutationVariables>;
export const ClockInDocument = gql`
    mutation ClockIn($input: ClockInOutInput!) {
  clockIn(input: $input) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type ClockInMutationFn = Apollo.MutationFunction<ClockInMutation, ClockInMutationVariables>;

/**
 * __useClockInMutation__
 *
 * To run a mutation, you first call `useClockInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClockInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clockInMutation, { data, loading, error }] = useClockInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClockInMutation(baseOptions?: Apollo.MutationHookOptions<ClockInMutation, ClockInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClockInMutation, ClockInMutationVariables>(ClockInDocument, options);
      }
export type ClockInMutationHookResult = ReturnType<typeof useClockInMutation>;
export type ClockInMutationResult = Apollo.MutationResult<ClockInMutation>;
export type ClockInMutationOptions = Apollo.BaseMutationOptions<ClockInMutation, ClockInMutationVariables>;
export const ClockOutDocument = gql`
    mutation ClockOut($input: ClockInOutInput!) {
  clockOut(input: $input) {
    ...WorkShift
  }
}
    ${WorkShiftFragmentDoc}
${EmployeeFragmentDoc}`;
export type ClockOutMutationFn = Apollo.MutationFunction<ClockOutMutation, ClockOutMutationVariables>;

/**
 * __useClockOutMutation__
 *
 * To run a mutation, you first call `useClockOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClockOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clockOutMutation, { data, loading, error }] = useClockOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClockOutMutation(baseOptions?: Apollo.MutationHookOptions<ClockOutMutation, ClockOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClockOutMutation, ClockOutMutationVariables>(ClockOutDocument, options);
      }
export type ClockOutMutationHookResult = ReturnType<typeof useClockOutMutation>;
export type ClockOutMutationResult = Apollo.MutationResult<ClockOutMutation>;
export type ClockOutMutationOptions = Apollo.BaseMutationOptions<ClockOutMutation, ClockOutMutationVariables>;